// import axios from 'axios';
// import React, { useState, useEffect, useCallback, useMemo } from 'react';

// // --- INTERFACE DEFINITIONS (UNCHANGED) ---

// interface Developer {
//     _id: string;
//     developerName: string;
//     developerEmail?: string[];
// }

// interface PriceTableType {
//     bhktype: string;
//     size: string;
//     price: string;
//     img: string;
// }

// interface AmenityImg {
//     icon: string;
//     label: string;
// }

// interface FAQ {
//     question: string;
//     answer: string;
// }

// interface ProjectData {
//     _id?: string;
//     name: string;
//     location: string;
//     city: string;
//     price: {
//         min: string;
//         max: string;
//     };
//     sizes: string;
//     configurations: string;
//     propertyType: string;
//     status: string;
//     reraId: string;
//     reraLink: string;
//     towers: string;
//     possession: string;
//     totalProjectArea: string;
//     floors: string;
//     units: string;
//     category: string;
//     youtubeid: string[];
//     description: string;
//     amenities: string[];
//     galleryImages: string[];
//     keyfeatures: string[];
//     highlight: string[];
//     highlightImg: string[];
//     bannerimg: string[];
//     faq: FAQ[];
//     mapLocation: string;
//     pdf: string;
//     priceTableType: PriceTableType[];
//     amenitiesImg: AmenityImg[];
//     metaKeywords: string;
//     metaTitle: string;
//     metaDesc: string;
//     metaSchema: string;
//     slug: string;
//     conalical: string;
//     siteMap: string[];
//     locationBulletPoint: string[];
//     sitePlan: string[];
//     isComplete: boolean;
//     formMessage: string;
//     latitude: string;
//     longitude: string;
//     developerId: string;
// }

// // --- API FUNCTIONS (UNCHANGED) ---

// const replaceImageToAPI = async (file: File, oldFilename: string): Promise<string> => {
//     const fd = new FormData();
//     fd.append("file", file);
//     fd.append("oldFilenames", oldFilename);
//     const res = await fetch("https://service.ireedindia.com/replace-files", {
//         method: "PATCH",
//         body: fd,
//     });

//     if (!res.ok) throw new Error(`Replace failed with status ${res.status}`);
//     const data = await res.json();

//     if (Array.isArray(data.uploadedFiles)) {
//         return data.uploadedFiles[0];
//     }
//     return data.uploadedFiles;
// };

// // --- COMPONENT START ---

// const ProjectDashboard: React.FC = () => {
//     const [developers, setDevelopers] = useState<Developer[]>([]);
//     const [projects, setProjects] = useState<ProjectData[]>([]);
//     const [loading, setLoading] = useState(false);
//     const [loadingProjects, setLoadingProjects] = useState(false);
//     const [successMessage, setSuccessMessage] = useState('');
//     const [errorMessage, setErrorMessage] = useState('');
//     const [activeTab, setActiveTab] = useState('basic');
//     const [viewMode, setViewMode] = useState<'form' | 'list'>('list');
//     const [editingProjectId, setEditingProjectId] = useState<string | null>(null);
//     const [isUploading, setIsUploading] = useState(false);

//     // Get user role from localStorage
//     const getUserRole = (): string => {
//         const userDetailsString = localStorage.getItem('userDetails');
//         const userDetails = userDetailsString ? JSON.parse(userDetailsString) : null;
//         return userDetails?.role || '';
//     };
//     const userRole = getUserRole();

//     const initialFormData: ProjectData = {
//         name: '',
//         location: '',
//         city: '',
//         price: { min: '', max: '' },
//         sizes: '',
//         configurations: '',
//         propertyType: 'Residential Apartment',
//         status: 'Launching Soon',
//         reraId: '',
//         reraLink: '',
//         towers: '',
//         possession: '',
//         totalProjectArea: '',
//         floors: '',
//         units: '',
//         category: 'Premium',
//         youtubeid: [''],
//         description: '',
//         amenities: [''],
//         galleryImages: [''],
//         keyfeatures: [''],
//         highlight: [''],
//         highlightImg: [''],
//         bannerimg: [''],
//         faq: [{ question: '', answer: '' }],
//         mapLocation: '',
//         pdf: '',
//         priceTableType: [{ bhktype: '', size: '', price: '', img: '' }],
//         amenitiesImg: [{ icon: '', label: '' }],
//         metaKeywords: '',
//         metaTitle: '',
//         metaDesc: '',
//         metaSchema: '',
//         slug: '',
//         conalical: '',
//         siteMap: [''],
//         locationBulletPoint: [''],
//         sitePlan: [''],
//         isComplete: false,
//         formMessage: '',
//         latitude: '',
//         longitude: '',
//         developerId: ''
//     };

//     const [formData, setFormData] = useState<ProjectData>(initialFormData);

//     // --- API CALLS (UNCHANGED) ---

//     const fetchDevelopers = async () => {
//         try {
//             const response = await fetch('https://service.ireedindia.com/v1/developers-all');
//             const data = await response.json();
//             setDevelopers(data.data || data);
//         } catch (error) {
//             setErrorMessage('Failed to fetch developers');
//             setTimeout(() => setErrorMessage(''), 3000);
//         }
//     };

//     const fetchProjects = useCallback(async () => {
//         setLoadingProjects(true);
//         setErrorMessage('');
//         try {
//             // Get role and userId from localStorage
//             const userDetailsString = localStorage.getItem('userDetails');
//             const userDetails = userDetailsString ? JSON.parse(userDetailsString) : null;
//             const role = userDetails?.role;
//             const userId = userDetails?.userId;

//             let url = 'https://service.ireedindia.com/v1/projects-all?page=1&limit=1000';

//             // If not admin, add userId as param
//             if (role !== 'admin' && userId) {
//                 url += `?userId=${encodeURIComponent(userId)}`;
//             }

//             console.log('🔗 Fetching projects from:', url);

//             const response = await fetch(url);
//             const data = await response.json();

//             if (response.ok) {
//                 const projectList = Array.isArray(data.data) ? data.data : Array.isArray(data) ? data : [];
//                 setProjects(projectList);
//             } else {
//                 setErrorMessage('Failed to fetch projects');
//                 setTimeout(() => setErrorMessage(''), 5000);
//             }
//         } catch (error) {
//             console.error('Fetch error:', error);
//             setErrorMessage('Failed to fetch projects. Please check your connection.');
//             setTimeout(() => setErrorMessage(''), 5000);
//         } finally {
//             setLoadingProjects(false);
//         }
//     }, []);

//     useEffect(() => {
//         fetchDevelopers();
//         fetchProjects();
//     }, [fetchProjects]);

//     // --- GROUPING LOGIC (NEW) ---

//     // Publish/unpublish filter for admin
//     const [publishFilter, setPublishFilter] = useState<'all' | 'published' | 'unpublished'>('all');

//     // Filtered projects for admin
//     const filteredProjects = useMemo(() => {
//         if (userRole === 'admin' && publishFilter !== 'all') {
//             return projects.filter(project =>
//                 publishFilter === 'published' ? project.isComplete : !project.isComplete
//             );
//         }
//         return projects;
//     }, [projects, userRole, publishFilter]);

//     const groupedProjects = useMemo(() => {
//         const groups: { [key: string]: ProjectData[] } = {};
//         filteredProjects.forEach(project => {
//             const developerKey = project.developerId || 'unknown';
//             if (!groups[developerKey]) {
//                 groups[developerKey] = [];
//             }
//             groups[developerKey].push(project);
//         });
//         return groups;
//     }, [filteredProjects]);

//     const getDeveloperName = useCallback((developerId: string | undefined): string => {
//         if (!developerId) return 'Unknown Developer';
//         const developer = developers.find(dev => dev._id === developerId);
//         return developer?.developerName || 'Developer ID: ' + developerId;
//     }, [developers]);


//     // --- FORM/UPLOAD/CRUD HANDLERS (OMITTED for brevity, as they are UNCHANGED) ---
//     // (In a real application, these functions would remain here)

//     const handleInputChange = (field: string, value: any) => {
//         setFormData(prev => ({ ...prev, [field]: value }));
//     };

//     const handleNestedInputChange = (field: string, subfield: string, value: string) => {
//         setFormData(prev => ({
//             ...prev,
//             [field]: { ...(prev[field as keyof ProjectData] as any), [subfield]: value }
//         }));
//     };

//     const handleArrayChange = (field: string, index: number, value: string) => {
//         const arr = [...(formData[field as keyof ProjectData] as string[])];
//         arr[index] = value;
//         handleInputChange(field, arr);
//     };

//     const addArrayItem = (field: string) => {
//         const arr = [...(formData[field as keyof ProjectData] as any[])];
//         if (field === 'faq') {
//             arr.push({ question: '', answer: '' });
//         } else if (field === 'priceTableType') {
//             arr.push({ bhktype: '', size: '', price: '', img: '' });
//         } else if (field === 'amenitiesImg') {
//             arr.push({ icon: '', label: '' });
//         } else {
//             arr.push('');
//         }
//         handleInputChange(field, arr);
//     };

//     const removeArrayItem = (field: string, index: number) => {
//         const arr = [...(formData[field as keyof ProjectData] as any[])];
//         arr.splice(index, 1);
//         handleInputChange(field, arr);
//     };

//     const handleObjectArrayChange = (field: string, index: number, subfield: string, value: string) => {
//         const arr = [...(formData[field as keyof ProjectData] as any[])];
//         arr[index] = { ...arr[index], [subfield]: value };
//         handleInputChange(field, arr);
//     };

//     const uploadFile = async (file: File): Promise<string> => {
//         if (file.size > 5 * 1024 * 1024) {
//             throw new Error('File size exceeds 5MB limit. Please select a smaller file.');
//         }
//         const formDataFile = new FormData();
//         formDataFile.append('file', file);

//         const response = await axios.post(`https://service.ireedindia.com/upload`, formDataFile);
//         return response.data.filename;
//     };

//     const handleFileOperation = async (file: File, oldUrl: string): Promise<string> => {
//         if (oldUrl) {
//             return await replaceImageToAPI(file, oldUrl);
//         } else {
//             return await uploadFile(file);
//         }
//     };


//     const handleImageUpload = async (field: keyof ProjectData, event: React.ChangeEvent<HTMLInputElement>) => {
//         const file = event.target.files?.[0];
//         if (!file) return;

//         const oldUrl = formData[field as keyof ProjectData] as string;

//         setIsUploading(true);
//         try {
//             const newUrl = await handleFileOperation(file, oldUrl);
//             handleInputChange(field as string, newUrl);
//             setSuccessMessage(oldUrl ? 'File replaced successfully!' : 'File uploaded successfully!');
//             setTimeout(() => setSuccessMessage(''), 2000);
//         } catch (error: any) {
//             console.error('Upload failed:', error);
//             setErrorMessage(error.message || 'Failed to upload/replace file');
//             setTimeout(() => setErrorMessage(''), 3000);
//         } finally {
//             setIsUploading(false);
//         }
//     };

//     const handleArrayImageUpload = async (field: keyof ProjectData, index: number, event: React.ChangeEvent<HTMLInputElement>) => {
//         const file = event.target.files?.[0];
//         if (!file) return;

//         const arrayField = formData[field as keyof ProjectData] as string[];
//         const oldUrl = arrayField[index] || '';

//         setIsUploading(true);
//         try {
//             const newUrl = await handleFileOperation(file, oldUrl);
//             handleArrayChange(field as string, index, newUrl);
//             setSuccessMessage(oldUrl ? 'Image replaced successfully!' : 'Image uploaded successfully!');
//             setTimeout(() => setSuccessMessage(''), 2000);
//         } catch (error: any) {
//             console.error('Upload failed:', error);
//             setErrorMessage(error.message || 'Failed to upload/replace image');
//             setTimeout(() => setErrorMessage(''), 3000);
//         } finally {
//             setIsUploading(false);
//         }
//     };

//     const handleObjectArrayImageUpload = async (field: keyof ProjectData, index: number, subfield: string, event: React.ChangeEvent<HTMLInputElement>) => {
//         const file = event.target.files?.[0];
//         if (!file) return;

//         const arrayField = formData[field as keyof ProjectData] as any[];
//         const oldUrl = arrayField[index][subfield] || '';

//         setIsUploading(true);
//         try {
//             const newUrl = await handleFileOperation(file, oldUrl);
//             handleObjectArrayChange(field as string, index, subfield, newUrl);
//             setSuccessMessage(oldUrl ? 'Image replaced successfully!' : 'Image uploaded successfully!');
//             setTimeout(() => setSuccessMessage(''), 2000);
//         } catch (error: any) {
//             console.error('Upload failed:', error);
//             setErrorMessage(error.message || 'Failed to upload/replace image');
//             setTimeout(() => setErrorMessage(''), 3000);
//         } finally {
//             setIsUploading(false);
//         }
//     };

//     const handleSubmit = async (e: React.FormEvent) => {
//         e.preventDefault();
//         setLoading(true);
//         setErrorMessage('');
//         setSuccessMessage('');

//         try {
//             // Get userId from localStorage
//             const userDetailsString = localStorage.getItem('userDetails');
//             const userDetails = userDetailsString ? JSON.parse(userDetailsString) : null;
//             const userId = userDetails?.userId;

//             let url, method;

//             if (editingProjectId) {
//                 url = `https://service.ireedindia.com/v1/projects/${editingProjectId}`;
//                 method = 'PATCH';
//             } else {
//                 url = 'https://service.ireedindia.com/v1/project-create';
//                 method = 'POST';
//             }

//             // Prepare payload with userId
//             const payload = {
//                 ...formData,
//                 userId: userId // Add userId to the payload
//             };

//             console.log('🚀 Submitting project with payload:', payload);

//             const response = await fetch(url, {
//                 method: method,
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify(payload)
//             });

//             const result = await response.json();

//             if (response.ok) {
//                 setSuccessMessage(editingProjectId ? 'Project updated successfully!' : 'Project created successfully!');
//                 setTimeout(() => setSuccessMessage(''), 3000);
//                 await fetchProjects();
//                 setViewMode('list');
//                 setFormData(initialFormData);
//                 setEditingProjectId(null);
//             } else {
//                 setErrorMessage(result.message || `Failed to ${editingProjectId ? 'update' : 'create'} project. Status: ${response.status}`);
//                 setTimeout(() => setErrorMessage(''), 5000);
//             }
//         } catch (error) {
//             console.error('Error:', error);
//             setErrorMessage('Network error occurred. Please try again.');
//             setTimeout(() => setErrorMessage(''), 5000);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleEdit = (project: ProjectData) => {
//         const projectToEdit: ProjectData = JSON.parse(JSON.stringify(project));

//         const normalizeArray = (arr: any[] | undefined, defaultItem: any = '') =>
//             (Array.isArray(arr) && arr.length > 0) ? arr : [defaultItem];

//         setFormData({
//             ...projectToEdit,
//             youtubeid: normalizeArray(projectToEdit.youtubeid),
//             amenities: normalizeArray(projectToEdit.amenities),
//             galleryImages: normalizeArray(projectToEdit.galleryImages),
//             keyfeatures: normalizeArray(projectToEdit.keyfeatures),
//             highlight: normalizeArray(projectToEdit.highlight),
//             highlightImg: normalizeArray(projectToEdit.highlightImg),
//             bannerimg: normalizeArray(projectToEdit.bannerimg),
//             siteMap: normalizeArray(projectToEdit.siteMap),
//             locationBulletPoint: normalizeArray(projectToEdit.locationBulletPoint),
//             sitePlan: normalizeArray(projectToEdit.sitePlan),
//             faq: normalizeArray(projectToEdit.faq, { question: '', answer: '' }),
//             priceTableType: normalizeArray(projectToEdit.priceTableType, { bhktype: '', size: '', price: '', img: '' }),
//             amenitiesImg: normalizeArray(projectToEdit.amenitiesImg, { icon: '', label: '' }),
//         });
//         setEditingProjectId(project._id || null);
//         setViewMode('form');
//         setActiveTab('basic');
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//     };

//     const handleDelete = async (projectId: string) => {
//         if (!window.confirm('Are you sure you want to delete this project? This action cannot be undone.')) {
//             return;
//         }

//         setLoading(true);
//         setErrorMessage('');

//         try {
//             const url = `https://service.ireedindia.com/v1/projects/${projectId}`;

//             const response = await fetch(url, {
//                 method: 'DELETE',
//                 headers: { 'Content-Type': 'application/json' }
//             });

//             if (response.ok || response.status === 204) {
//                 setSuccessMessage('Project deleted successfully!');
//                 setTimeout(() => setSuccessMessage(''), 3000);
//                 await fetchProjects();
//             } else {
//                 const result = await response.json().catch(() => ({ message: 'Unknown error' }));
//                 setErrorMessage(result.message || `Failed to delete project. Status: ${response.status}`);
//                 setTimeout(() => setErrorMessage(''), 5000);
//             }
//         } catch (error) {
//             console.error('Delete error:', error);
//             setErrorMessage('Network error occurred while deleting. Please try again.');
//             setTimeout(() => setErrorMessage(''), 5000);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleReset = () => {
//         const userConfirmed = window.confirm('Are you sure you want to reset the form?');
//         if (userConfirmed) {
//             setFormData(initialFormData);
//             setEditingProjectId(null);
//         }
//     };

//     const handleCancelEdit = () => {
//         if (window.confirm('Are you sure you want to cancel? All unsaved changes will be lost.')) {
//             setFormData(initialFormData);
//             setEditingProjectId(null);
//             setViewMode('list');
//         }
//     };


//     // --- STYLES & UI CONFIG (Mostly UNCHANGED) ---

//     const tabs = [
//         { id: 'basic', label: 'Basic Info', icon: '🏢' },
//         { id: 'details', label: 'Details', icon: '📍' },
//         { id: 'media', label: 'Media', icon: '📤' },
//         { id: 'pricing', label: 'Pricing', icon: '₹' },
//         { id: 'seo', label: 'SEO', icon: '🔍' }
//     ];

//     const inputStyle: React.CSSProperties = {
//         width: '100%',
//         padding: '10px 12px',
//         border: '1px solid #e5e7eb',
//         borderRadius: '8px',
//         fontSize: '14px',
//         transition: 'all 0.2s',
//         outline: 'none',
//         boxSizing: 'border-box',
//     };

//     const labelStyle: React.CSSProperties = {
//         display: 'block',
//         marginBottom: '6px',
//         fontSize: '14px',
//         fontWeight: '500',
//         color: '#374151'
//     };

//     const buttonStyle: React.CSSProperties = {
//         padding: '10px 16px',
//         borderRadius: '8px',
//         border: 'none',
//         cursor: 'pointer',
//         fontSize: '14px',
//         fontWeight: '500',
//         transition: 'all 0.2s',
//         display: 'flex',
//         alignItems: 'center',
//         gap: '6px'
//     };

//     const fileInputStyle: React.CSSProperties = {
//         width: '100%',
//         padding: '10px 12px',
//         border: '1px solid #e5e7eb',
//         borderRadius: '8px',
//         fontSize: '14px',
//         cursor: 'pointer',
//         backgroundColor: '#f9fafb',
//         boxSizing: 'border-box',
//     };

//     const arrayInputGroupStyle: React.CSSProperties = {
//         display: 'flex',
//         gap: '10px',
//         marginBottom: '10px'
//     };

//     const sectionHeaderStyle: React.CSSProperties = {
//         fontSize: '20px',
//         fontWeight: '600',
//         color: '#1f2937',
//         marginBottom: '16px',
//         borderBottom: '1px solid #e5e7eb',
//         paddingBottom: '8px'
//     };

//     // --- CARD STYLES ---

//     const cardContainerStyle: React.CSSProperties = {
//         display: 'grid',
//         gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
//         gap: '30px',
//         paddingTop: '16px',
//         marginBottom: '40px' // Add space below each developer group
//     };

//     const developerHeaderStyle: React.CSSProperties = {
//         fontSize: '24px',
//         fontWeight: '700',
//         color: '#2a3290',
//         marginTop: '30px',
//         marginBottom: '10px',
//         paddingBottom: '5px',
//         borderBottom: '3px solid #667eea',
//     };

//     const cardStyle: React.CSSProperties = {
//         border: '1px solid #e5e7eb',
//         borderRadius: '12px',
//         background: '#ffffff',
//         overflow: 'hidden',
//         boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
//         transition: 'transform 0.3s, box-shadow 0.3s',
//         display: 'flex',
//         flexDirection: 'column',
//     };

//     const cardHoverStyle: React.CSSProperties = {
//         transform: 'translateY(-5px)',
//         boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
//     };

//     const cardHeaderStyle: React.CSSProperties = {
//         padding: '20px 24px',
//         borderBottom: '1px solid #f3f4f6',
//         backgroundColor: '#f9fafb',
//     };

//     const cardBodyStyle: React.CSSProperties = {
//         padding: '24px',
//         flexGrow: 1,
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-between',
//     };

//     const cardFooterStyle: React.CSSProperties = {
//         padding: '20px 24px',
//         borderTop: '1px solid #f3f4f6',
//         display: 'flex',
//         gap: '10px',
//         justifyContent: 'flex-end',
//     };

//     const cardBadgeBase: React.CSSProperties = {
//         padding: '4px 10px',
//         borderRadius: '6px',
//         fontSize: '12px',
//         fontWeight: '600',
//     };

//     const getStatusBadgeStyle = (status: string): React.CSSProperties => {
//         switch (status) {
//             case 'Ready to Move': return { ...cardBadgeBase, backgroundColor: '#d1fae5', color: '#065f46' };
//             case 'Under Construction': return { ...cardBadgeBase, backgroundColor: '#fef3c7', color: '#92400e' };
//             case 'New Launch': return { ...cardBadgeBase, backgroundColor: '#e0e7ff', color: '#3730a3' };
//             default: return { ...cardBadgeBase, backgroundColor: '#f3f4f6', color: '#6b7280' };
//         }
//     };

//     const getCategoryBadgeStyle = (category: string): React.CSSProperties => {
//         switch (category) {
//             case 'Luxury': return { ...cardBadgeBase, backgroundColor: '#fce7f3', color: '#9d174d' };
//             case 'Affordable': return { ...cardBadgeBase, backgroundColor: '#dbeafe', color: '#1e40af' };
//             default: return { ...cardBadgeBase, backgroundColor: '#e5e7eb', color: '#374151' };
//         }
//     };

//     // --- RENDER ---

//     return (
//         <div style={{ minHeight: '100vh', padding: '20px', boxShadow: 'inset 0 0 10px rgba(0,0,0,0.05)' }}>
//             <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
//                 <div style={{ background: 'white', borderRadius: '16px', boxShadow: '0 20px 60px rgba(0,0,0,0.15)', overflow: 'hidden' }}>

//                     {/* Header */}
//                     <div style={{ padding: '32px', color: 'white', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
//                         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
//                             <div>
//                                 <h1 style={{ margin: 0, fontSize: '32px', color: "#2a3290", fontWeight: '700', display: 'flex', alignItems: 'center', gap: '12px' }}>
//                                     <span style={{ fontSize: '36px' }}>🏢</span>
//                                     Project Management Dashboard
//                                 </h1>
//                                 <p style={{ margin: '8px 0 0', opacity: 0.9, fontSize: '16px' }}>
//                                     {editingProjectId ? 'Editing Project' : viewMode === 'form' ? 'Create new real estate project' : 'Manage your real estate projects'}
//                                 </p>
//                             </div>
//                             {/* All users can create projects */}
//                             <button
//                                 onClick={() => {
//                                     if (viewMode === 'form' && (editingProjectId || JSON.stringify(formData) !== JSON.stringify(initialFormData))) {
//                                         handleCancelEdit();
//                                     } else {
//                                         setViewMode(viewMode === 'form' ? 'list' : 'form');
//                                         if (viewMode === 'list') {
//                                             setFormData(initialFormData);
//                                             setEditingProjectId(null);
//                                             setActiveTab('basic');
//                                         }
//                                     }
//                                 }}
//                                 style={{
//                                     ...buttonStyle,
//                                     background: viewMode === 'form' ? '#ef4444' : '#667eea',
//                                     color: 'white',
//                                     border: 'none',
//                                     padding: '12px 24px',
//                                     fontSize: '15px'
//                                 }}
//                             >
//                                 {viewMode === 'form' ? (editingProjectId ? '❌ Cancel Edit' : '📋 View Projects') : '➕ Create New Project'}
//                             </button>
//                         </div>
//                     </div>

//                     {/* Messages */}
//                     {successMessage && (
//                         <div style={{ background: '#d1fae5', color: '#065f46', padding: '16px 32px', borderLeft: '4px solid #10b981' }}>
//                             ✓ {successMessage}
//                         </div>
//                     )}
//                     {errorMessage && (
//                         <div style={{ background: '#fee2e2', color: '#991b1b', padding: '16px 32px', borderLeft: '4px solid #ef4444' }}>
//                             ✗ {errorMessage}
//                         </div>
//                     )}

//                     {/* Project List View - REFACTORED FOR GROUPING */}
//                     {viewMode === 'list' && (
//                         <div style={{ padding: '32px' }}>
//                             <div style={{ marginBottom: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
//                                 <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '600', color: '#1f2937' }}>
//                                     All Projects ({filteredProjects.length})
//                                 </h2>
//                                 <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
//                                     {/* Publish/Unpublish Filter for Admin */}
//                                     {userRole === 'admin' && (
//                                         <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
//                                             <span style={{ fontWeight: 500, fontSize: 15 }}>Filter:</span>
//                                             <select
//                                                 value={publishFilter}
//                                                 onChange={e => setPublishFilter(e.target.value as 'all' | 'published' | 'unpublished')}
//                                                 style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #d1d5db', fontSize: 15 }}
//                                             >
//                                                 <option value="all">All</option>
//                                                 <option value="published">Published</option>
//                                                 <option value="unpublished">Unpublished</option>
//                                             </select>
//                                         </div>
//                                     )}
//                                     <button
//                                         onClick={fetchProjects}
//                                         disabled={loadingProjects}
//                                         style={{
//                                             ...buttonStyle,
//                                             background: '#e0e7ff',
//                                             color: '#3730a3',
//                                             opacity: loadingProjects ? 0.6 : 1
//                                         }}
//                                     >
//                                         🔄 {loadingProjects ? 'Refreshing...' : 'Refresh'}
//                                     </button>
//                                 </div>
//                             </div>

//                             {loadingProjects ? (
//                                 <div style={{ textAlign: 'center', padding: '60px', color: '#6b7280' }}>
//                                     <div style={{ fontSize: '48px', marginBottom: '16px' }}>⏳</div>
//                                     <p style={{ fontSize: '18px' }}>Loading projects...</p>
//                                 </div>
//                             ) : projects.length === 0 ? (
//                                 <div style={{ textAlign: 'center', padding: '60px', color: '#6b7280' }}>
//                                     <div style={{ fontSize: '48px', marginBottom: '16px' }}>📦</div>
//                                     <p style={{ fontSize: '18px', marginBottom: '24px' }}>No projects found</p>
//                                     {/* All users can create their first project */}
//                                     <button
//                                         onClick={() => setViewMode('form')}
//                                         style={{
//                                             ...buttonStyle,
//                                             background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//                                             color: 'white',
//                                             padding: '12px 24px',
//                                             margin: '0 auto'
//                                         }}
//                                     >
//                                         ➕ Create Your First Project
//                                     </button>
//                                 </div>
//                             ) : (
//                                 <div>
//                                     {Object.keys(groupedProjects).map((developerId) => (
//                                         <div key={developerId}>
//                                             <h2 style={developerHeaderStyle}>
//                                                 {getDeveloperName(developerId === 'unknown' ? undefined : developerId)}
//                                                 <span style={{ fontSize: '18px', fontWeight: '500', color: '#6b7280', marginLeft: '10px' }}>
//                                                     ({groupedProjects[developerId].length} Projects)
//                                                 </span>
//                                             </h2>

//                                             <div style={cardContainerStyle}>
//                                                 {groupedProjects[developerId].map((project: ProjectData, index) => (
//                                                     <div
//                                                         key={project._id || index}
//                                                         style={cardStyle}
//                                                         onMouseEnter={(e) => Object.assign(e.currentTarget.style, cardHoverStyle)}
//                                                         onMouseLeave={(e) => Object.assign(e.currentTarget.style, cardStyle)}
//                                                     >

//                                                         {/* Card Header: Title and Status/Category Badges */}
//                                                         <div style={cardHeaderStyle}>
//                                                             <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '10px' }}>
//                                                                 <span style={getStatusBadgeStyle(project.status)}>
//                                                                     {project.status || 'N/A'}
//                                                                 </span>
//                                                                 <span style={getCategoryBadgeStyle(project.category)}>
//                                                                     {project.category || 'N/A'}
//                                                                 </span>
//                                                                 {project.isComplete && (
//                                                                     <span style={{ ...cardBadgeBase, backgroundColor: '#dcfce7', color: '#166534' }}>
//                                                                         ✓ Complete
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                             <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '700', color: '#2a3290' }}>
//                                                                 {project.name || 'Unnamed Project'}
//                                                             </h3>
//                                                             <p style={{ margin: '4px 0 0', fontSize: '14px', color: '#6b7280', display: 'flex', alignItems: 'center', gap: '5px' }}>
//                                                                 📍 {project.location || 'No location'}, {project.city || 'N/A'}
//                                                             </p>
//                                                         </div>

//                                                         {/* Card Body: Key Details */}
//                                                         <div style={cardBodyStyle}>
//                                                             <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', color: '#4b5563', fontSize: '14px' }}>
//                                                                 <DetailItem label="Configuration" value={project.configurations || 'N/A'} />
//                                                                 <DetailItem label="Size Range" value={project.sizes || 'N/A'} />
//                                                                 <DetailItem label="Price Range" value={`₹${project.price.min || 'N/A'} - ₹${project.price.max || 'N/A'}`} />
//                                                                 <DetailItem label="Possession" value={project.possession || 'N/A'} />
//                                                                 <DetailItem label="Total Area" value={project.totalProjectArea || 'N/A'} />
//                                                                 <DetailItem label="Units" value={project.units || 'N/A'} />

//                                                                 <div style={{ gridColumn: 'span 2 / span 2', borderTop: '1px solid #e5e7eb', paddingTop: '10px', marginTop: '5px' }}>
//                                                                     <strong style={{ color: '#374151', display: 'block' }}>Property Type:</strong>
//                                                                     <span style={{ color: '#6b7280' }}>
//                                                                         {project.propertyType || 'N/A'}
//                                                                     </span>
//                                                                 </div>
//                                                             </div>
//                                                         </div>

//                                                         {/* Card Footer: Actions */}
//                                                         <div style={cardFooterStyle}>
//                                                             <button
//                                                                 onClick={() => handleEdit(project)}
//                                                                 style={{
//                                                                     ...buttonStyle,
//                                                                     background: '#e0e7ff',
//                                                                     color: '#3730a3',
//                                                                     padding: '10px 18px',
//                                                                     fontWeight: '600'
//                                                                 }}
//                                                             >
//                                                                 ✏️ Edit Details
//                                                             </button>
//                                                             {/* Show Delete button only for admin users */}
//                                                             {userRole === 'admin' && (
//                                                                 <button
//                                                                     onClick={() => handleDelete(project._id as string)}
//                                                                     disabled={loading}
//                                                                     style={{
//                                                                         ...buttonStyle,
//                                                                         background: '#fee2e2',
//                                                                         color: '#991b1b',
//                                                                         padding: '10px 18px',
//                                                                         opacity: loading ? 0.6 : 1,
//                                                                         cursor: loading ? 'not-allowed' : 'pointer',
//                                                                         fontWeight: '600'
//                                                                     }}
//                                                                 >
//                                                                     🗑️ Delete
//                                                                 </button>
//                                                             )}
//                                                         </div>
//                                                     </div>
//                                                 ))}
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </div>
//                             )}
//                         </div>
//                     )}
//                     {/* END Project List View */}

//                     {/* Form View (UNCHANGED for form fields and API logic) */}
//                     {viewMode === 'form' && (
//                         <>
//                             {/* Tabs */}
//                             <div style={{ borderBottom: '1px solid #e5e7eb', background: '#f9fafb' }}>
//                                 <div style={{ display: 'flex', padding: '0 32px', gap: '8px', overflowX: 'auto' }}>
//                                     {tabs.map(tab => (
//                                         <button
//                                             key={tab.id}
//                                             onClick={() => setActiveTab(tab.id)}
//                                             style={{
//                                                 padding: '16px 24px',
//                                                 border: 'none',
//                                                 background: activeTab === tab.id ? 'white' : 'transparent',
//                                                 color: activeTab === tab.id ? '#667eea' : '#6b7280',
//                                                 borderBottom: activeTab === tab.id ? '3px solid #667eea' : 'none',
//                                                 cursor: 'pointer',
//                                                 fontWeight: '600',
//                                                 fontSize: '14px',
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 gap: '8px',
//                                                 transition: 'all 0.2s'
//                                             }}
//                                         >
//                                             <span style={{ fontSize: '18px' }}>{tab.icon}</span>
//                                             {tab.label}
//                                         </button>
//                                     ))}
//                                 </div>
//                             </div>

//                             <form onSubmit={handleSubmit} style={{ padding: '32px' }}>

//                                 {/* 1. Basic Info Tab */}
//                                 {activeTab === 'basic' && (
//                                     <div style={{ display: 'grid', gap: '24px' }}>
//                                         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>

//                                             {/* Project Name */}
//                                             <div>
//                                                 <label style={labelStyle}>Project Name *</label>
//                                                 <input
//                                                     type="text"
//                                                     value={formData.name}
//                                                     onChange={(e) => handleInputChange('name', e.target.value)}
//                                                     style={inputStyle}
//                                                     required
//                                                 />
//                                             </div>

//                                             {/* Developer */}
//                                             <div>
//                                                 <label style={labelStyle}>Developer *</label>
//                                                 <select
//                                                     value={formData.developerId}
//                                                     onChange={(e) => handleInputChange('developerId', e.target.value)}
//                                                     style={inputStyle}
//                                                     required
//                                                 >
//                                                     <option value="">Select Developer</option>
//                                                     {developers.map(dev => (
//                                                         <option key={dev._id} value={dev._id}>{dev.developerName}</option>
//                                                     ))}
//                                                 </select>
//                                             </div>

//                                             {/* Location */}
//                                             <div>
//                                                 <label style={labelStyle}>Location *</label>
//                                                 <input
//                                                     type="text"
//                                                     value={formData.location}
//                                                     onChange={(e) => handleInputChange('location', e.target.value)}
//                                                     style={inputStyle}
//                                                     required
//                                                 />
//                                             </div>

//                                             {/* City */}
//                                             <div>
//                                                 <label style={labelStyle}>City *</label>
//                                                 <input
//                                                     type="text"
//                                                     value={formData.city}
//                                                     onChange={(e) => handleInputChange('city', e.target.value)}
//                                                     style={inputStyle}
//                                                     required
//                                                 />
//                                             </div>

//                                             {/* Property Type */}
//                                             <div>
//                                                 <label style={labelStyle}>Property Type</label>
//                                                 <select
//                                                     value={formData.propertyType}
//                                                     onChange={(e) => handleInputChange('propertyType', e.target.value)}
//                                                     style={inputStyle}
//                                                 >
//                                                     <option>Residential Apartment</option>
//                                                     <option>Villa</option>
//                                                     <option>Plot</option>
//                                                     <option>Commercial</option>
//                                                 </select>
//                                             </div>

//                                             {/* Status */}
//                                             <div>
//                                                 <label style={labelStyle}>Status</label>
//                                                 <select
//                                                     value={formData.status}
//                                                     onChange={(e) => handleInputChange('status', e.target.value)}
//                                                     style={inputStyle}
//                                                 >
//                                                     <option>Launching Soon</option>
//                                                     <option>Under Construction</option>
//                                                     <option>Ready to Move</option>
//                                                     <option>New Launch</option>
//                                                 </select>
//                                             </div>

//                                             {/* Category */}
//                                             <div>
//                                                 <label style={labelStyle}>Category</label>
//                                                 <select
//                                                     value={formData.category}
//                                                     onChange={(e) => handleInputChange('category', e.target.value)}
//                                                     style={inputStyle}
//                                                 >
//                                                     <option>Premium</option>
//                                                     <option>Luxury</option>
//                                                     <option>Affordable</option>
//                                                 </select>
//                                             </div>

//                                             {/* Configurations */}
//                                             <div>
//                                                 <label style={labelStyle}>Configurations</label>
//                                                 <input
//                                                     type="text"
//                                                     value={formData.configurations}
//                                                     onChange={(e) => handleInputChange('configurations', e.target.value)}
//                                                     style={inputStyle}
//                                                     placeholder="e.g., 2, 3 & 4 BHK"
//                                                 />
//                                             </div>
//                                         </div>

//                                         {/* Description */}
//                                         <div>
//                                             <label style={labelStyle}>Description</label>
//                                             <textarea
//                                                 value={formData.description}
//                                                 onChange={(e) => handleInputChange('description', e.target.value)}
//                                                 style={{ ...inputStyle, minHeight: '100px' }}
//                                                 placeholder="A detailed description of the project..."
//                                             />
//                                         </div>

//                                         {/* Price Range */}
//                                         <div style={{ display: 'flex', gap: '20px' }}>
//                                             <div style={{ flex: 1 }}>
//                                                 <label style={labelStyle}>Minimum Price (e.g., 50 Lac)</label>
//                                                 <input
//                                                     type="text"
//                                                     value={formData.price.min}
//                                                     onChange={(e) => handleNestedInputChange('price', 'min', e.target.value)}
//                                                     style={inputStyle}
//                                                     placeholder="e.g., 50 Lac"
//                                                 />
//                                             </div>
//                                             <div style={{ flex: 1 }}>
//                                                 <label style={labelStyle}>Maximum Price (e.g., 1.5 Cr)</label>
//                                                 <input
//                                                     type="text"
//                                                     value={formData.price.max}
//                                                     onChange={(e) => handleNestedInputChange('price', 'max', e.target.value)}
//                                                     style={inputStyle}
//                                                     placeholder="e.g., 1.5 Cr"
//                                                 />
//                                             </div>
//                                         </div>

//                                         {/* Amenities with Icons */}
//                                         <div style={{ marginTop: '24px' }}>
//                                             <h3 style={sectionHeaderStyle}>Amenities with Icons</h3>
//                                             {formData.amenitiesImg.map((amenity, index) => (
//                                                 <div key={index} style={{ border: '1px solid #e5e7eb', padding: '15px', borderRadius: '8px', marginBottom: '10px', position: 'relative' }}>
//                                                     <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
//                                                         <div>
//                                                             <label style={labelStyle}>Amenity Label</label>
//                                                             <input
//                                                                 type="text"
//                                                                 value={amenity.label}
//                                                                 onChange={(e) => handleObjectArrayChange('amenitiesImg', index, 'label', e.target.value)}
//                                                                 style={inputStyle}
//                                                                 placeholder="e.g., Swimming Pool"
//                                                             />
//                                                         </div>
//                                                         <div>
//                                                             <label style={labelStyle}>Icon (Upload or URL)</label>
//                                                             <input
//                                                                 type="file"
//                                                                 onChange={(e) => handleObjectArrayImageUpload('amenitiesImg', index, 'icon', e)}
//                                                                 style={fileInputStyle}
//                                                                 accept="image/*"
//                                                                 disabled={isUploading}
//                                                             />
//                                                             <input
//                                                                 type="text"
//                                                                 value={amenity.icon}
//                                                                 onChange={(e) => handleObjectArrayChange('amenitiesImg', index, 'icon', e.target.value)}
//                                                                 style={{ ...inputStyle, marginTop: '5px' }}
//                                                                 placeholder="Or paste URL here"
//                                                             />
//                                                         </div>
//                                                     </div>
//                                                     {formData.amenitiesImg.length > 1 && (
//                                                         <button
//                                                             type="button"
//                                                             onClick={() => removeArrayItem('amenitiesImg', index)}
//                                                             style={{ ...buttonStyle, background: '#fecaca', color: '#dc2626', position: 'absolute', top: '10px', right: '10px', padding: '5px 10px' }}
//                                                         >
//                                                             Remove
//                                                         </button>
//                                                     )}
//                                                 </div>
//                                             ))}
//                                             <button
//                                                 type="button"
//                                                 onClick={() => addArrayItem('amenitiesImg')}
//                                                 style={{ ...buttonStyle, background: '#fef3c7', color: '#92400e' }}
//                                             >
//                                                 + Add Amenity with Icon
//                                             </button>
//                                         </div>

//                                         {/* Is Complete Checkbox - Only for Admin */}
//                                         {userRole === 'admin' && (
//                                             <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
//                                                 <label style={{ ...labelStyle, marginBottom: 0 }}>Project Complete?</label>
//                                                 <input
//                                                     type="checkbox"
//                                                     checked={formData.isComplete}
//                                                     onChange={(e) => handleInputChange('isComplete', e.target.checked)}
//                                                     style={{ width: 'auto', transform: 'scale(1.2)' }}
//                                                 />
//                                             </div>
//                                         )}

//                                     </div>
//                                 )}

//                                 {/* 2. Details Tab */}
//                                 {activeTab === 'details' && (
//                                     <div style={{ display: 'grid', gap: '24px' }}>
//                                         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>

//                                             {/* Towers */}
//                                             <div>
//                                                 <label style={labelStyle}>Towers</label>
//                                                 <input type="text" value={formData.towers} onChange={(e) => handleInputChange('towers', e.target.value)} style={inputStyle} placeholder="e.g., 5" />
//                                             </div>

//                                             {/* Floors */}
//                                             <div>
//                                                 <label style={labelStyle}>Floors</label>
//                                                 <input type="text" value={formData.floors} onChange={(e) => handleInputChange('floors', e.target.value)} style={inputStyle} placeholder="e.g., G+20" />
//                                             </div>

//                                             {/* Units */}
//                                             <div>
//                                                 <label style={labelStyle}>Units</label>
//                                                 <input type="text" value={formData.units} onChange={(e) => handleInputChange('units', e.target.value)} style={inputStyle} placeholder="e.g., 450" />
//                                             </div>

//                                             {/* Sizes */}
//                                             <div>
//                                                 <label style={labelStyle}>Sizes (Range)</label>
//                                                 <input type="text" value={formData.sizes} onChange={(e) => handleInputChange('sizes', e.target.value)} style={inputStyle} placeholder="e.g., 1200 - 2500 Sq.Ft." />
//                                             </div>

//                                             {/* Total Project Area */}
//                                             <div>
//                                                 <label style={labelStyle}>Total Project Area</label>
//                                                 <input type="text" value={formData.totalProjectArea} onChange={(e) => handleInputChange('totalProjectArea', e.target.value)} style={inputStyle} placeholder="e.g., 10 Acres" />
//                                             </div>

//                                             {/* Possession */}
//                                             <div>
//                                                 <label style={labelStyle}>Possession</label>
//                                                 <input type="text" value={formData.possession} onChange={(e) => handleInputChange('possession', e.target.value)} style={inputStyle} placeholder="e.g., December 2026" />
//                                             </div>

//                                             {/* RERA ID */}
//                                             <div>
//                                                 <label style={labelStyle}>RERA ID</label>
//                                                 <input type="text" value={formData.reraId} onChange={(e) => handleInputChange('reraId', e.target.value)} style={inputStyle} />
//                                             </div>

//                                             {/* RERA Link */}
//                                             <div>
//                                                 <label style={labelStyle}>RERA Link</label>
//                                                 <input type="url" value={formData.reraLink} onChange={(e) => handleInputChange('reraLink', e.target.value)} style={inputStyle} placeholder="https://" />
//                                             </div>

//                                             {/* Map Location URL */}
//                                             <div>
//                                                 <label style={labelStyle}>Map Location (iFrame URL)</label>
//                                                 <input type="url" value={formData.mapLocation} onChange={(e) => handleInputChange('mapLocation', e.target.value)} style={inputStyle} placeholder="https://maps.google.com/embed?..." />
//                                             </div>

//                                             {/* Latitude */}
//                                             <div>
//                                                 <label style={labelStyle}>Latitude</label>
//                                                 <input type="text" value={formData.latitude} onChange={(e) => handleInputChange('latitude', e.target.value)} style={inputStyle} />
//                                             </div>

//                                             {/* Longitude */}
//                                             <div>
//                                                 <label style={labelStyle}>Longitude</label>
//                                                 <input type="text" value={formData.longitude} onChange={(e) => handleInputChange('longitude', e.target.value)} style={inputStyle} />
//                                             </div>
//                                         </div>

//                                         {/* Location Bullet Points */}
//                                         <h3 style={sectionHeaderStyle}>Location Highlights/Bullet Points</h3>
//                                         <div>
//                                             {formData.locationBulletPoint.map((point, index) => (
//                                                 <div key={index} style={arrayInputGroupStyle}>
//                                                     <input
//                                                         type="text"
//                                                         value={point}
//                                                         onChange={(e) => handleArrayChange('locationBulletPoint', index, e.target.value)}
//                                                         style={inputStyle}
//                                                         placeholder={`Location Point ${index + 1}`}
//                                                     />
//                                                     {formData.locationBulletPoint.length > 1 && (
//                                                         <button
//                                                             type="button"
//                                                             onClick={() => removeArrayItem('locationBulletPoint', index)}
//                                                             style={{ ...buttonStyle, background: '#fecaca', color: '#dc2626', flexShrink: 0 }}
//                                                         >
//                                                             -
//                                                         </button>
//                                                     )}
//                                                 </div>
//                                             ))}
//                                             <button
//                                                 type="button"
//                                                 onClick={() => addArrayItem('locationBulletPoint')}
//                                                 style={{ ...buttonStyle, background: '#dbeafe', color: '#1e40af' }}
//                                             >
//                                                 + Add Location Point
//                                             </button>
//                                         </div>

//                                         {/* FAQ Section */}
//                                         <h3 style={sectionHeaderStyle}>FAQ (Frequently Asked Questions)</h3>
//                                         {formData.faq.map((faqItem, index) => (
//                                             <div key={index} style={{ border: '1px solid #e5e7eb', padding: '15px', borderRadius: '8px', marginBottom: '10px', position: 'relative' }}>
//                                                 <div style={{ display: 'grid', gap: '10px' }}>
//                                                     <div>
//                                                         <label style={labelStyle}>Question</label>
//                                                         <input
//                                                             type="text"
//                                                             value={faqItem.question}
//                                                             onChange={(e) => handleObjectArrayChange('faq', index, 'question', e.target.value)}
//                                                             style={inputStyle}
//                                                             placeholder="Enter question"
//                                                         />
//                                                     </div>
//                                                     <div>
//                                                         <label style={labelStyle}>Answer</label>
//                                                         <textarea
//                                                             value={faqItem.answer}
//                                                             onChange={(e) => handleObjectArrayChange('faq', index, 'answer', e.target.value)}
//                                                             style={{ ...inputStyle, minHeight: '80px' }}
//                                                             placeholder="Enter answer"
//                                                         />
//                                                     </div>
//                                                 </div>
//                                                 {formData.faq.length > 1 && (
//                                                     <button
//                                                         type="button"
//                                                         onClick={() => removeArrayItem('faq', index)}
//                                                         style={{ ...buttonStyle, background: '#fecaca', color: '#dc2626', position: 'absolute', top: '10px', right: '10px', padding: '5px 10px' }}
//                                                     >
//                                                         Remove
//                                                     </button>
//                                                 )}
//                                             </div>
//                                         ))}
//                                         <button
//                                             type="button"
//                                             onClick={() => addArrayItem('faq')}
//                                             style={{ ...buttonStyle, background: '#fef3c7', color: '#92400e' }}
//                                         >
//                                             + Add FAQ
//                                         </button>

//                                     </div>
//                                 )}

//                                 {/* 3. Media Tab */}
//                                 {activeTab === 'media' && (
//                                     <div style={{ display: 'grid', gap: '24px' }}>

//                                         <h3 style={sectionHeaderStyle}>Banner Images</h3>
//                                         <div>
//                                             {formData.bannerimg.map((imgUrl, index) => (
//                                                 <div key={index} style={{ ...arrayInputGroupStyle, alignItems: 'center' }}>
//                                                     <input
//                                                         type="file"
//                                                         onChange={(e) => handleArrayImageUpload('bannerimg', index, e)}
//                                                         style={fileInputStyle}
//                                                         accept="image/*"
//                                                         disabled={isUploading}
//                                                     />
//                                                     <input
//                                                         type="text"
//                                                         value={imgUrl}
//                                                         onChange={(e) => handleArrayChange('bannerimg', index, e.target.value)}
//                                                         style={{ ...inputStyle, flex: 1 }}
//                                                         placeholder="Or paste URL here"
//                                                     />
//                                                     {formData.bannerimg.length > 1 && (
//                                                         <button
//                                                             type="button"
//                                                             onClick={() => removeArrayItem('bannerimg', index)}
//                                                             style={{ ...buttonStyle, background: '#fecaca', color: '#dc2626', flexShrink: 0 }}
//                                                         >
//                                                             -
//                                                         </button>
//                                                     )}
//                                                 </div>
//                                             ))}
//                                             <button
//                                                 type="button"
//                                                 onClick={() => addArrayItem('bannerimg')}
//                                                 style={{ ...buttonStyle, background: '#d1fae5', color: '#065f46' }}
//                                             >
//                                                 + Add Banner Image
//                                             </button>
//                                         </div>

//                                         <h3 style={sectionHeaderStyle}>Gallery Images</h3>
//                                         <div>
//                                             {formData.galleryImages.map((imgUrl, index) => (
//                                                 <div key={index} style={{ ...arrayInputGroupStyle, alignItems: 'center' }}>
//                                                     <input
//                                                         type="file"
//                                                         onChange={(e) => handleArrayImageUpload('galleryImages', index, e)}
//                                                         style={fileInputStyle}
//                                                         accept="image/*"
//                                                         disabled={isUploading}
//                                                     />
//                                                     <input
//                                                         type="text"
//                                                         value={imgUrl}
//                                                         onChange={(e) => handleArrayChange('galleryImages', index, e.target.value)}
//                                                         style={{ ...inputStyle, flex: 1 }}
//                                                         placeholder="Or paste URL here"
//                                                     />
//                                                     {formData.galleryImages.length > 1 && (
//                                                         <button
//                                                             type="button"
//                                                             onClick={() => removeArrayItem('galleryImages', index)}
//                                                             style={{ ...buttonStyle, background: '#fecaca', color: '#dc2626', flexShrink: 0 }}
//                                                         >
//                                                             -
//                                                         </button>
//                                                     )}
//                                                 </div>
//                                             ))}
//                                             <button
//                                                 type="button"
//                                                 onClick={() => addArrayItem('galleryImages')}
//                                                 style={{ ...buttonStyle, background: '#d1fae5', color: '#065f46' }}
//                                             >
//                                                 + Add Gallery Image
//                                             </button>
//                                         </div>

//                                         <h3 style={sectionHeaderStyle}>Project Highlights with Images</h3>
//                                         {formData.highlight.map((text, index) => (
//                                             <div key={index} style={{ border: '1px solid #e5e7eb', padding: '15px', borderRadius: '8px', position: 'relative', marginBottom: '10px' }}>
//                                                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
//                                                     <div>
//                                                         <label style={labelStyle}>Highlight Text</label>
//                                                         <input
//                                                             type="text"
//                                                             value={text}
//                                                             onChange={(e) => handleArrayChange('highlight', index, e.target.value)}
//                                                             style={inputStyle}
//                                                             placeholder="e.g., Luxurious Clubhouse"
//                                                         />
//                                                     </div>
//                                                     <div>
//                                                         <label style={labelStyle}>Highlight Image URL or Upload</label>
//                                                         <input
//                                                             type="file"
//                                                             onChange={(e) => handleArrayImageUpload('highlightImg', index, e)}
//                                                             style={fileInputStyle}
//                                                             accept="image/*"
//                                                             disabled={isUploading}
//                                                         />
//                                                         <input
//                                                             type="text"
//                                                             value={formData.highlightImg[index] || ''}
//                                                             onChange={(e) => handleArrayChange('highlightImg', index, e.target.value)}
//                                                             style={{ ...inputStyle, marginTop: '5px' }}
//                                                             placeholder="Or paste URL here"
//                                                         />
//                                                     </div>
//                                                 </div>
//                                                 {formData.highlight.length > 1 && (
//                                                     <button
//                                                         type="button"
//                                                         onClick={() => { removeArrayItem('highlight', index); removeArrayItem('highlightImg', index); }}
//                                                         style={{ ...buttonStyle, background: '#fecaca', color: '#dc2626', position: 'absolute', top: '10px', right: '10px', padding: '5px 10px' }}
//                                                     >
//                                                         Remove
//                                                     </button>
//                                                 )}
//                                             </div>
//                                         ))}
//                                         <button
//                                             type="button"
//                                             onClick={() => { addArrayItem('highlight'); addArrayItem('highlightImg'); }}
//                                             style={{ ...buttonStyle, background: '#fef3c7', color: '#92400e' }}
//                                         >
//                                             + Add Highlight
//                                         </button>

//                                         <h3 style={sectionHeaderStyle}>PDF Brochure/File</h3>
//                                         <div>
//                                             <label style={labelStyle}>Project PDF/Brochure (Upload or URL)</label>
//                                             <input
//                                                 type="file"
//                                                 onChange={(e) => handleImageUpload('pdf', e)}
//                                                 style={fileInputStyle}
//                                                 accept=".pdf"
//                                                 disabled={isUploading}
//                                             />
//                                             <input
//                                                 type="text"
//                                                 value={formData.pdf}
//                                                 onChange={(e) => handleInputChange('pdf', e.target.value)}
//                                                 style={{ ...inputStyle, marginTop: '5px' }}
//                                                 placeholder="Or paste PDF URL here"
//                                             />
//                                             {isUploading && <p style={{ color: '#059669', marginTop: '10px' }}>Uploading PDF...</p>}
//                                             {formData.pdf && <p style={{ marginTop: '10px' }}>Current PDF: <a href={formData.pdf} target="_blank" rel="noopener noreferrer" style={{ color: '#667eea', textDecoration: 'underline' }}>View PDF</a></p>}
//                                         </div>
//                                     </div>
//                                 )}

//                                 {/* 4. Pricing Tab */}
//                                 {activeTab === 'pricing' && (
//                                     <div style={{ display: 'grid', gap: '24px' }}>
//                                         <h3 style={sectionHeaderStyle}>Price Table Configuration</h3>
//                                         {formData.priceTableType.map((row, index) => (
//                                             <div key={index} style={{ border: '1px solid #e5e7eb', padding: '20px', borderRadius: '8px', position: 'relative', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', marginBottom: '10px' }}>

//                                                 {/* BHK Type */}
//                                                 <div>
//                                                     <label style={labelStyle}>BHK Type</label>
//                                                     <input
//                                                         type="text"
//                                                         value={row.bhktype}
//                                                         onChange={(e) => handleObjectArrayChange('priceTableType', index, 'bhktype', e.target.value)}
//                                                         style={inputStyle}
//                                                         placeholder="e.g., 2 BHK"
//                                                     />
//                                                 </div>

//                                                 {/* Size */}
//                                                 <div>
//                                                     <label style={labelStyle}>Size</label>
//                                                     <input
//                                                         type="text"
//                                                         value={row.size}
//                                                         onChange={(e) => handleObjectArrayChange('priceTableType', index, 'size', e.target.value)}
//                                                         style={inputStyle}
//                                                         placeholder="e.g., 1250 Sq.Ft."
//                                                     />
//                                                 </div>

//                                                 {/* Price */}
//                                                 <div>
//                                                     <label style={labelStyle}>Price</label>
//                                                     <input
//                                                         type="text"
//                                                         value={row.price}
//                                                         onChange={(e) => handleObjectArrayChange('priceTableType', index, 'price', e.target.value)}
//                                                         style={inputStyle}
//                                                         placeholder="e.g., 1.25 Cr"
//                                                     />
//                                                 </div>

//                                                 {/* Image Upload */}
//                                                 <div style={{ gridColumn: 'span 2 / span 2' }}>
//                                                     <label style={labelStyle}>Image (Floor Plan/Unit Map)</label>
//                                                     <input
//                                                         type="file"
//                                                         onChange={(e) => handleObjectArrayImageUpload('priceTableType', index, 'img', e)}
//                                                         style={fileInputStyle}
//                                                         accept="image/*"
//                                                         disabled={isUploading}
//                                                     />
//                                                     <input
//                                                         type="text"
//                                                         value={row.img}
//                                                         onChange={(e) => handleObjectArrayChange('priceTableType', index, 'img', e.target.value)}
//                                                         style={{ ...inputStyle, marginTop: '5px' }}
//                                                         placeholder="Or paste URL here"
//                                                     />
//                                                 </div>

//                                                 {formData.priceTableType.length > 1 && (
//                                                     <button
//                                                         type="button"
//                                                         onClick={() => removeArrayItem('priceTableType', index)}
//                                                         style={{ ...buttonStyle, background: '#fecaca', color: '#dc2626', position: 'absolute', top: '10px', right: '10px', padding: '5px 10px' }}
//                                                     >
//                                                         Remove
//                                                     </button>
//                                                 )}
//                                             </div>
//                                         ))}
//                                         <button
//                                             type="button"
//                                             onClick={() => addArrayItem('priceTableType')}
//                                             style={{ ...buttonStyle, background: '#d1fae5', color: '#065f46' }}
//                                         >
//                                             + Add Price Row
//                                         </button>
//                                     </div>
//                                 )}

//                                 {/* 5. SEO Tab */}
//                                 {activeTab === 'seo' && (
//                                     <div style={{ display: 'grid', gap: '24px' }}>
//                                         <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '20px' }}>

//                                             {/* Meta Title */}
//                                             <div>
//                                                 <label style={labelStyle}>Meta Title</label>
//                                                 <input type="text" value={formData.metaTitle} onChange={(e) => handleInputChange('metaTitle', e.target.value)} style={inputStyle} />
//                                             </div>

//                                             {/* Meta Description */}
//                                             <div>
//                                                 <label style={labelStyle}>Meta Description</label>
//                                                 <textarea value={formData.metaDesc} onChange={(e) => handleInputChange('metaDesc', e.target.value)} style={{ ...inputStyle, minHeight: '80px' }} />
//                                             </div>

//                                             {/* Meta Keywords */}
//                                             <div>
//                                                 <label style={labelStyle}>Meta Keywords (Comma separated)</label>
//                                                 <textarea value={formData.metaKeywords} onChange={(e) => handleInputChange('metaKeywords', e.target.value)} style={{ ...inputStyle, minHeight: '80px' }} />
//                                             </div>

//                                             {/* Meta Schema */}
//                                             <div>
//                                                 <label style={labelStyle}>Meta Schema (JSON-LD)</label>
//                                                 <textarea value={formData.metaSchema} onChange={(e) => handleInputChange('metaSchema', e.target.value)} style={{ ...inputStyle, minHeight: '150px', fontFamily: 'monospace' }} />
//                                             </div>

//                                             {/* Slug */}
//                                             <div>
//                                                 <label style={labelStyle}>Slug (URL-friendly name)</label>
//                                                 <input type="text" value={formData.slug} onChange={(e) => handleInputChange('slug', e.target.value)} style={inputStyle} placeholder="project-name-in-city" />
//                                             </div>

//                                             {/* Canonical URL */}
//                                             <div>
//                                                 <label style={labelStyle}>Canonical URL (Optional)</label>
//                                                 <input type="url" value={formData.conalical} onChange={(e) => handleInputChange('conalical', e.target.value)} style={inputStyle} placeholder="https://yourwebsite.com/projects/slug" />
//                                             </div>
//                                         </div>
//                                     </div>
//                                 )}

//                                 {/* Form Message (Internal Note/Status) */}
//                                 <div style={{ marginTop: '24px', borderTop: '1px solid #e5e7eb', paddingTop: '24px' }}>
//                                     <label style={labelStyle}>Internal Form Message / Status Note</label>
//                                     <input type="text" value={formData.formMessage} onChange={(e) => handleInputChange('formMessage', e.target.value)} style={inputStyle} />
//                                 </div>

//                                 {/* Submit/Action Buttons */}
//                                 <div style={{ marginTop: '32px', paddingTop: '24px', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
//                                     <button
//                                         type="button"
//                                         onClick={handleReset}
//                                         style={{ ...buttonStyle, background: '#f3f4f6', color: '#4b5563' }}
//                                         disabled={loading}
//                                     >
//                                         <span style={{ fontSize: '16px' }}>🧹</span> Reset Form
//                                     </button>
//                                     <button
//                                         type="submit"
//                                         disabled={loading}
//                                         style={{
//                                             ...buttonStyle,
//                                             background: 'linear-gradient(90deg, #10b981 0%, #059669 100%)',
//                                             color: 'white',
//                                             padding: '12px 24px',
//                                             opacity: loading ? 0.7 : 1,
//                                             cursor: loading ? 'not-allowed' : 'pointer'
//                                         }}
//                                     >
//                                         {loading ? (
//                                             'Processing...'
//                                         ) : (
//                                             <>
//                                                 <span style={{ fontSize: '16px' }}>💾 </span> {editingProjectId ? 'Update Project' : 'Create Project'}
//                                             </>
//                                         )}
//                                     </button>
//                                 </div>
//                             </form>
//                         </>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// };

// // Helper component for cleaner detail display in the card
// const DetailItem: React.FC<{ label: string, value: string }> = ({ label, value }) => (
//     <div style={{ margin: 0 }}>
//         <strong style={{ color: '#374151', display: 'block', marginBottom: '2px' }}>{label}:</strong>
//         <span style={{ color: '#6b7280' }}>{value}</span>
//     </div>
// );


// export default ProjectDashboard;


import axios from 'axios';
import React, { useState, useEffect, useCallback, useMemo } from 'react';

// --- INTERFACE DEFINITIONS (UNCHANGED) ---

interface Developer {
    _id: string;
    developerName: string;
    developerEmail?: string[];
}

interface PriceTableType {
    bhktype: string;
    size: string;
    price: string;
    img: string;
}

interface AmenityImg {
    icon: string;
    label: string;
}

interface FAQ {
    question: string;
    answer: string;
}

interface ProjectData {
    _id?: string;
    name: string;
    location: string;
    city: string;
    price: {
        min: string;
        max: string;
    };
    sizes: string;
    configurations: string;
    propertyType: string;
    status: string;
    reraId: string;
    reraLink: string;
    towers: string;
    possession: string;
    totalProjectArea: string;
    floors: string;
    units: string;
    category: string;
    youtubeid: string[];
    description: string;
    amenities: string[];
    galleryImages: string[];
    keyfeatures: string[];
    highlight: string[];
    highlightImg: string[];
    bannerimg: string[];
    faq: FAQ[];
    mapLocation: string;
    pdf: string;
    priceTableType: PriceTableType[];
    amenitiesImg: AmenityImg[];
    metaKeywords: string;
    metaTitle: string;
    metaDesc: string;
    metaSchema: string;
    slug: string;
    conalical: string;
    siteMap: string[];
    locationBulletPoint: string[];
    sitePlan: string[];
    isComplete: boolean;
    formMessage: string;
    latitude: string;
    longitude: string;
    developerId: string;
}

// --- API FUNCTIONS (UNCHANGED) ---

const replaceImageToAPI = async (file: File, oldFilename: string): Promise<string> => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("oldFilenames", oldFilename);
    const res = await fetch("https://service.ireedindia.com/replace-files", {
        method: "PATCH",
        body: fd,
    });

    if (!res.ok) throw new Error(`Replace failed with status ${res.status}`);
    const data = await res.json();

    if (Array.isArray(data.uploadedFiles)) {
        return data.uploadedFiles[0];
    }
    return data.uploadedFiles;
};

// --- COMPONENT START ---



const ProjectDashboard: React.FC = () => {
    const [developers, setDevelopers] = useState<Developer[]>([]);
    const [projects, setProjects] = useState<ProjectData[]>([]);
    const [loading, setLoading] = useState(false);
    const [loadingProjects, setLoadingProjects] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [activeTab, setActiveTab] = useState('basic');
    const [viewMode, setViewMode] = useState<'form' | 'list'>('list');
    const [editingProjectId, setEditingProjectId] = useState<string | null>(null);
    const [isUploading, setIsUploading] = useState(false);

    // Get user role from localStorage
    const getUserRole = (): string => {
        const userDetailsString = localStorage.getItem('userDetails');
        const userDetails = userDetailsString ? JSON.parse(userDetailsString) : null;
        return userDetails?.role || '';
    };
    const userRole = getUserRole();

    const initialFormData: ProjectData = {
        name: '',
        location: '',
        city: '',
        price: { min: '', max: '' },
        sizes: '',
        configurations: '',
        propertyType: 'Residential Apartment',
        status: 'Launching Soon',
        reraId: '',
        reraLink: '',
        towers: '',
        possession: '',
        totalProjectArea: '',
        floors: '',
        units: '',
        category: 'Premium',
        youtubeid: [''],
        description: '',
        amenities: [''],
        galleryImages: [''],
        keyfeatures: [''],
        highlight: [''],
        highlightImg: [''],
        bannerimg: [''],
        faq: [{ question: '', answer: '' }],
        mapLocation: '',
        pdf: '',
        priceTableType: [{ bhktype: '', size: '', price: '', img: '' }],
        amenitiesImg: [{ icon: '', label: '' }],
        metaKeywords: '',
        metaTitle: '',
        metaDesc: '',
        metaSchema: '',
        slug: '',
        conalical: '',
        siteMap: [''],
        locationBulletPoint: [''],
        sitePlan: [''],
        isComplete: false,
        formMessage: '',
        latitude: '',
        longitude: '',
        developerId: ''
    };

    const [formData, setFormData] = useState<ProjectData>(initialFormData);

    // --- API CALLS (UNCHANGED) ---

    const fetchDevelopers = async () => {
        try {
            const response = await fetch('https://service.ireedindia.com/v1/developers-all');
            const data = await response.json();
            setDevelopers(data.data || data);
        } catch (error) {
            setErrorMessage('Failed to fetch developers');
            setTimeout(() => setErrorMessage(''), 3000);
        }
    };

    const fetchProjects = useCallback(async () => {
        setLoadingProjects(true);
        setErrorMessage('');
        try {
            // Get role and userId from localStorage
            const userDetailsString = localStorage.getItem('userDetails');
            const userDetails = userDetailsString ? JSON.parse(userDetailsString) : null;
            const role = userDetails?.role;
            const userId = userDetails?.userId;

            let url = 'https://service.ireedindia.com/v1/projects-all?page=1&limit=1000';

            // If not admin, add userId as param
            if (role !== 'admin' && userId) {
                url += `?userId=${encodeURIComponent(userId)}`;
            }

            console.log('🔗 Fetching projects from:', url);

            const response = await fetch(url);
            const data = await response.json();

            if (response.ok) {
                const projectList = Array.isArray(data.data) ? data.data : Array.isArray(data) ? data : [];
                setProjects(projectList);
            } else {
                setErrorMessage('Failed to fetch projects');
                setTimeout(() => setErrorMessage(''), 5000);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setErrorMessage('Failed to fetch projects. Please check your connection.');
            setTimeout(() => setErrorMessage(''), 5000);
        } finally {
            setLoadingProjects(false);
        }
    }, []);

    useEffect(() => {
        fetchDevelopers();
        fetchProjects();
    }, [fetchProjects]);

    // --- GROUPING LOGIC (NEW) ---

    // Publish/unpublish filter for admin
    const [publishFilter, setPublishFilter] = useState<'all' | 'published' | 'unpublished'>('all');

    // Filtered projects for admin
    const filteredProjects = useMemo(() => {
        if (userRole === 'admin' && publishFilter !== 'all') {
            return projects.filter(project =>
                publishFilter === 'published' ? project.isComplete : !project.isComplete
            );
        }
        return projects;
    }, [projects, userRole, publishFilter]);

    const groupedProjects = useMemo(() => {
        const groups: { [key: string]: ProjectData[] } = {};
        filteredProjects.forEach(project => {
            const developerKey = project.developerId || 'unknown';
            if (!groups[developerKey]) {
                groups[developerKey] = [];
            }
            groups[developerKey].push(project);
        });
        return groups;
    }, [filteredProjects]);

    const getDeveloperName = useCallback((developerId: string | undefined): string => {
        if (!developerId) return 'Unknown Developer';
        const developer = developers.find(dev => dev._id === developerId);
        return developer?.developerName || 'Developer ID: ' + developerId;
    }, [developers]);


    // --- FORM/UPLOAD/CRUD HANDLERS (OMITTED for brevity, as they are UNCHANGED) ---
    // (In a real application, these functions would remain here)

    const handleInputChange = (field: string, value: any) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const handleNestedInputChange = (field: string, subfield: string, value: string) => {
        setFormData(prev => ({
            ...prev,
            [field]: { ...(prev[field as keyof ProjectData] as any), [subfield]: value }
        }));
    };

    const handleArrayChange = (field: string, index: number, value: string) => {
        const arr = [...(formData[field as keyof ProjectData] as string[])];
        arr[index] = value;
        handleInputChange(field, arr);
    };

    const addArrayItem = (field: string) => {
        const arr = [...(formData[field as keyof ProjectData] as any[])];
        if (field === 'faq') {
            arr.push({ question: '', answer: '' });
        } else if (field === 'priceTableType') {
            arr.push({ bhktype: '', size: '', price: '', img: '' });
        } else if (field === 'amenitiesImg') {
            arr.push({ icon: '', label: '' });
        } else {
            arr.push('');
        }
        handleInputChange(field, arr);
    };

    const removeArrayItem = (field: string, index: number) => {
        const arr = [...(formData[field as keyof ProjectData] as any[])];
        arr.splice(index, 1);
        handleInputChange(field, arr);
    };

    const handleObjectArrayChange = (field: string, index: number, subfield: string, value: string) => {
        const arr = [...(formData[field as keyof ProjectData] as any[])];
        arr[index] = { ...arr[index], [subfield]: value };
        handleInputChange(field, arr);
    };

    const uploadFile = async (file: File): Promise<string> => {
        if (file.size > 5 * 1024 * 1024) {
            throw new Error('File size exceeds 5MB limit. Please select a smaller file.');
        }
        const formDataFile = new FormData();
        formDataFile.append('file', file);

        const response = await axios.post(`https://service.ireedindia.com/upload`, formDataFile);
        return response.data.filename;
    };

    const handleFileOperation = async (file: File, oldUrl: string): Promise<string> => {
        if (oldUrl) {
            return await replaceImageToAPI(file, oldUrl);
        } else {
            return await uploadFile(file);
        }
    };


    const handleImageUpload = async (field: keyof ProjectData, event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) return;

        const oldUrl = formData[field as keyof ProjectData] as string;

        setIsUploading(true);
        try {
            const newUrl = await handleFileOperation(file, oldUrl);
            handleInputChange(field as string, newUrl);
            setSuccessMessage(oldUrl ? 'File replaced successfully!' : 'File uploaded successfully!');
            setTimeout(() => setSuccessMessage(''), 2000);
        } catch (error: any) {
            console.error('Upload failed:', error);
            setErrorMessage(error.message || 'Failed to upload/replace file');
            setTimeout(() => setErrorMessage(''), 3000);
        } finally {
            setIsUploading(false);
        }
    };

    const handleArrayImageUpload = async (field: keyof ProjectData, index: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) return;

        const arrayField = formData[field as keyof ProjectData] as string[];
        const oldUrl = arrayField[index] || '';

        setIsUploading(true);
        try {
            const newUrl = await handleFileOperation(file, oldUrl);
            handleArrayChange(field as string, index, newUrl);
            setSuccessMessage(oldUrl ? 'Image replaced successfully!' : 'Image uploaded successfully!');
            setTimeout(() => setSuccessMessage(''), 2000);
        } catch (error: any) {
            console.error('Upload failed:', error);
            setErrorMessage(error.message || 'Failed to upload/replace image');
            setTimeout(() => setErrorMessage(''), 3000);
        } finally {
            setIsUploading(false);
        }
    };

    const handleObjectArrayImageUpload = async (field: keyof ProjectData, index: number, subfield: string, event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) return;

        const arrayField = formData[field as keyof ProjectData] as any[];
        const oldUrl = arrayField[index][subfield] || '';

        setIsUploading(true);
        try {
            const newUrl = await handleFileOperation(file, oldUrl);
            handleObjectArrayChange(field as string, index, subfield, newUrl);
            setSuccessMessage(oldUrl ? 'Image replaced successfully!' : 'Image uploaded successfully!');
            setTimeout(() => setSuccessMessage(''), 2000);
        } catch (error: any) {
            console.error('Upload failed:', error);
            setErrorMessage(error.message || 'Failed to upload/replace image');
            setTimeout(() => setErrorMessage(''), 3000);
        } finally {
            setIsUploading(false);
        }
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setErrorMessage('');
        setSuccessMessage('');

        try {
            // Get userId from localStorage
            const userDetailsString = localStorage.getItem('userDetails');
            const userDetails = userDetailsString ? JSON.parse(userDetailsString) : null;
            const userId = userDetails?.userId;

            let url, method;

            if (editingProjectId) {
                url = `https://service.ireedindia.com/v1/projects/${editingProjectId}`;
                method = 'PATCH';
            } else {
                url = 'https://service.ireedindia.com/v1/project-create';
                method = 'POST';
            }

            // Prepare payload with userId
            const payload = {
                ...formData,
                userId: userId // Add userId to the payload
            };

            console.log('🚀 Submitting project with payload:', payload);

            const response = await fetch(url, {
                method: method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            const result = await response.json();

            if (response.ok) {
                setSuccessMessage(editingProjectId ? 'Project updated successfully!' : 'Project created successfully!');
                setTimeout(() => setSuccessMessage(''), 3000);
                await fetchProjects();
                setViewMode('list');
                setFormData(initialFormData);
                setEditingProjectId(null);
            } else {
                setErrorMessage(result.message || `Failed to ${editingProjectId ? 'update' : 'create'} project. Status: ${response.status}`);
                setTimeout(() => setErrorMessage(''), 5000);
            }
        } catch (error) {
            console.error('Error:', error);
            setErrorMessage('Network error occurred. Please try again.');
            setTimeout(() => setErrorMessage(''), 5000);
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = (project: ProjectData) => {
        const projectToEdit: ProjectData = JSON.parse(JSON.stringify(project));

        const normalizeArray = (arr: any[] | undefined, defaultItem: any = '') =>
            (Array.isArray(arr) && arr.length > 0) ? arr : [defaultItem];

        setFormData({
            ...projectToEdit,
            youtubeid: normalizeArray(projectToEdit.youtubeid),
            amenities: normalizeArray(projectToEdit.amenities),
            galleryImages: normalizeArray(projectToEdit.galleryImages),
            keyfeatures: normalizeArray(projectToEdit.keyfeatures),
            highlight: normalizeArray(projectToEdit.highlight),
            highlightImg: normalizeArray(projectToEdit.highlightImg),
            bannerimg: normalizeArray(projectToEdit.bannerimg),
            siteMap: normalizeArray(projectToEdit.siteMap),
            locationBulletPoint: normalizeArray(projectToEdit.locationBulletPoint),
            sitePlan: normalizeArray(projectToEdit.sitePlan),
            faq: normalizeArray(projectToEdit.faq, { question: '', answer: '' }),
            priceTableType: normalizeArray(projectToEdit.priceTableType, { bhktype: '', size: '', price: '', img: '' }),
            amenitiesImg: normalizeArray(projectToEdit.amenitiesImg, { icon: '', label: '' }),
        });
        setEditingProjectId(project._id || null);
        setViewMode('form');
        setActiveTab('basic');
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleDelete = async (projectId: string) => {
        if (!window.confirm('Are you sure you want to delete this project? This action cannot be undone.')) {
            return;
        }

        setLoading(true);
        setErrorMessage('');

        try {
            const url = `https://service.ireedindia.com/v1/projects/${projectId}`;

            const response = await fetch(url, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' }
            });

            if (response.ok || response.status === 204) {
                setSuccessMessage('Project deleted successfully!');
                setTimeout(() => setSuccessMessage(''), 3000);
                await fetchProjects();
            } else {
                const result = await response.json().catch(() => ({ message: 'Unknown error' }));
                setErrorMessage(result.message || `Failed to delete project. Status: ${response.status}`);
                setTimeout(() => setErrorMessage(''), 5000);
            }
        } catch (error) {
            console.error('Delete error:', error);
            setErrorMessage('Network error occurred while deleting. Please try again.');
            setTimeout(() => setErrorMessage(''), 5000);
        } finally {
            setLoading(false);
        }
    };

    const handleReset = () => {
        const userConfirmed = window.confirm('Are you sure you want to reset the form?');
        if (userConfirmed) {
            setFormData(initialFormData);
            setEditingProjectId(null);
        }
    };

    const handleCancelEdit = () => {
        if (window.confirm('Are you sure you want to cancel? All unsaved changes will be lost.')) {
            setFormData(initialFormData);
            setEditingProjectId(null);
            setViewMode('list');
        }
    };


    // --- STYLES & UI CONFIG (Mostly UNCHANGED) ---

    const tabs = [
        { id: 'basic', label: 'Basic Info', icon: '🏢' },
        { id: 'details', label: 'Details', icon: '📍' },
        { id: 'media', label: 'Media', icon: '📤' },
        { id: 'pricing', label: 'Pricing', icon: '₹' },
        { id: 'seo', label: 'SEO', icon: '🔍' }
    ];

    const inputStyle: React.CSSProperties = {
        width: '100%',
        padding: '10px 12px',
        border: '1px solid #e5e7eb',
        borderRadius: '8px',
        fontSize: '14px',
        transition: 'all 0.2s',
        outline: 'none',
        boxSizing: 'border-box',
    };

    const labelStyle: React.CSSProperties = {
        display: 'block',
        marginBottom: '6px',
        fontSize: '14px',
        fontWeight: '500',
        color: '#374151'
    };

    const buttonStyle: React.CSSProperties = {
        padding: '10px 16px',
        borderRadius: '8px',
        border: 'none',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '500',
        transition: 'all 0.2s',
        display: 'flex',
        alignItems: 'center',
        gap: '6px'
    };

    const fileInputStyle: React.CSSProperties = {
        width: '100%',
        padding: '10px 12px',
        border: '1px solid #e5e7eb',
        borderRadius: '8px',
        fontSize: '14px',
        cursor: 'pointer',
        backgroundColor: '#f9fafb',
        boxSizing: 'border-box',
    };

    const arrayInputGroupStyle: React.CSSProperties = {
        display: 'flex',
        gap: '10px',
        marginBottom: '10px'
    };

    const sectionHeaderStyle: React.CSSProperties = {
        fontSize: '20px',
        fontWeight: '600',
        color: '#1f2937',
        marginBottom: '16px',
        borderBottom: '1px solid #e5e7eb',
        paddingBottom: '8px'
    };

    // --- CARD STYLES ---

    const cardContainerStyle: React.CSSProperties = {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
        gap: '30px',
        paddingTop: '16px',
        marginBottom: '40px' // Add space below each developer group
    };

    const developerHeaderStyle: React.CSSProperties = {
        fontSize: '24px',
        fontWeight: '700',
        color: '#2a3290',
        marginTop: '30px',
        marginBottom: '10px',
        paddingBottom: '5px',
        borderBottom: '3px solid #667eea',
    };

    const cardStyle: React.CSSProperties = {
        border: '1px solid #e5e7eb',
        borderRadius: '12px',
        background: '#ffffff',
        overflow: 'hidden',
        boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
        transition: 'transform 0.3s, box-shadow 0.3s',
        display: 'flex',
        flexDirection: 'column',
    };

    const cardHoverStyle: React.CSSProperties = {
        transform: 'translateY(-5px)',
        boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
    };

    const cardHeaderStyle: React.CSSProperties = {
        padding: '20px 24px',
        borderBottom: '1px solid #f3f4f6',
        backgroundColor: '#f9fafb',
    };

    const cardBodyStyle: React.CSSProperties = {
        padding: '24px',
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    };

    const cardFooterStyle: React.CSSProperties = {
        padding: '20px 24px',
        borderTop: '1px solid #f3f4f6',
        display: 'flex',
        gap: '10px',
        justifyContent: 'flex-end',
    };

    const cardBadgeBase: React.CSSProperties = {
        padding: '4px 10px',
        borderRadius: '6px',
        fontSize: '12px',
        fontWeight: '600',
    };

    const getStatusBadgeStyle = (status: string): React.CSSProperties => {
        switch (status) {
            case 'Ready to Move': return { ...cardBadgeBase, backgroundColor: '#d1fae5', color: '#065f46' };
            case 'Under Construction': return { ...cardBadgeBase, backgroundColor: '#fef3c7', color: '#92400e' };
            case 'New Launch': return { ...cardBadgeBase, backgroundColor: '#e0e7ff', color: '#3730a3' };
            default: return { ...cardBadgeBase, backgroundColor: '#f3f4f6', color: '#6b7280' };
        }
    };

    const getCategoryBadgeStyle = (category: string): React.CSSProperties => {
        switch (category) {
            case 'Luxury': return { ...cardBadgeBase, backgroundColor: '#fce7f3', color: '#9d174d' };
            case 'Affordable': return { ...cardBadgeBase, backgroundColor: '#dbeafe', color: '#1e40af' };
            default: return { ...cardBadgeBase, backgroundColor: '#e5e7eb', color: '#374151' };
        }
    };

    // --- RENDER ---

    return (
        <div style={{ minHeight: '100vh', padding: '20px', boxShadow: 'inset 0 0 10px rgba(0,0,0,0.05)' }}>
            <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
                <div style={{ background: 'white', borderRadius: '16px', boxShadow: '0 20px 60px rgba(0,0,0,0.15)', overflow: 'hidden' }}>

                    {/* Header */}
                    <div style={{ padding: '32px', color: 'white', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
                            <div>
                                <h1 style={{ margin: 0, fontSize: '32px', color: "#2a3290", fontWeight: '700', display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <span style={{ fontSize: '36px' }}>🏢</span>
                                    Project Management Dashboard
                                </h1>
                                <p style={{ margin: '8px 0 0', opacity: 0.9, fontSize: '16px' }}>
                                    {editingProjectId ? 'Editing Project' : viewMode === 'form' ? 'Create new real estate project' : 'Manage your real estate projects'}
                                </p>
                            </div>
                            {/* All users can create projects */}
                            <button
                                onClick={() => {
                                    if (viewMode === 'form' && (editingProjectId || JSON.stringify(formData) !== JSON.stringify(initialFormData))) {
                                        handleCancelEdit();
                                    } else {
                                        setViewMode(viewMode === 'form' ? 'list' : 'form');
                                        if (viewMode === 'list') {
                                            setFormData(initialFormData);
                                            setEditingProjectId(null);
                                            setActiveTab('basic');
                                        }
                                    }
                                }}
                                style={{
                                    ...buttonStyle,
                                    background: viewMode === 'form' ? '#ef4444' : '#667eea',
                                    color: 'white',
                                    border: 'none',
                                    padding: '12px 24px',
                                    fontSize: '15px'
                                }}
                            >
                                {viewMode === 'form' ? (editingProjectId ? '❌ Cancel Edit' : '📋 View Projects') : '➕ Create New Project'}
                            </button>
                        </div>
                    </div>

                    {/* Messages */}
                    {successMessage && (
                        <div style={{ background: '#d1fae5', color: '#065f46', padding: '16px 32px', borderLeft: '4px solid #10b981' }}>
                            ✓ {successMessage}
                        </div>
                    )}
                    {errorMessage && (
                        <div style={{ background: '#fee2e2', color: '#991b1b', padding: '16px 32px', borderLeft: '4px solid #ef4444' }}>
                            ✗ {errorMessage}
                        </div>
                    )}

                    {/* Project List View - REFACTORED FOR GROUPING */}
                    {viewMode === 'list' && (
                        <div style={{ padding: '32px' }}>
                            <div style={{ marginBottom: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
                                <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '600', color: '#1f2937' }}>
                                    All Projects ({filteredProjects.length})
                                </h2>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                                    {/* Publish/Unpublish Filter for Admin */}
                                    {userRole === 'admin' && (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                            <span style={{ fontWeight: 500, fontSize: 15 }}>Filter:</span>
                                            <select
                                                value={publishFilter}
                                                onChange={e => setPublishFilter(e.target.value as 'all' | 'published' | 'unpublished')}
                                                style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #d1d5db', fontSize: 15 }}
                                            >
                                                <option value="all">All</option>
                                                <option value="published">Published</option>
                                                <option value="unpublished">Unpublished</option>
                                            </select>
                                        </div>
                                    )}
                                    <button
                                        onClick={fetchProjects}
                                        disabled={loadingProjects}
                                        style={{
                                            ...buttonStyle,
                                            background: '#e0e7ff',
                                            color: '#3730a3',
                                            opacity: loadingProjects ? 0.6 : 1
                                        }}
                                    >
                                        🔄 {loadingProjects ? 'Refreshing...' : 'Refresh'}
                                    </button>
                                </div>
                            </div>

                            {loadingProjects ? (
                                <div style={{ textAlign: 'center', padding: '60px', color: '#6b7280' }}>
                                    <div style={{ fontSize: '48px', marginBottom: '16px' }}>⏳</div>
                                    <p style={{ fontSize: '18px' }}>Loading projects...</p>
                                </div>
                            ) : projects.length === 0 ? (
                                <div style={{ textAlign: 'center', padding: '60px', color: '#6b7280' }}>
                                    <div style={{ fontSize: '48px', marginBottom: '16px' }}>📦</div>
                                    <p style={{ fontSize: '18px', marginBottom: '24px' }}>No projects found</p>
                                    {/* All users can create their first project */}
                                    <button
                                        onClick={() => setViewMode('form')}
                                        style={{
                                            ...buttonStyle,
                                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                            color: 'white',
                                            padding: '12px 24px',
                                            margin: '0 auto'
                                        }}
                                    >
                                        ➕ Create Your First Project
                                    </button>
                                </div>
                            ) : (
                                <div>
                                    {Object.keys(groupedProjects).map((developerId) => (
                                        <div key={developerId}>
                                            <h2 style={developerHeaderStyle}>
                                                {getDeveloperName(developerId === 'unknown' ? undefined : developerId)}
                                                <span style={{ fontSize: '18px', fontWeight: '500', color: '#6b7280', marginLeft: '10px' }}>
                                                    ({groupedProjects[developerId].length} Projects)
                                                </span>
                                            </h2>

                                            <div style={cardContainerStyle}>
                                                {groupedProjects[developerId].map((project: ProjectData, index) => (
                                                    <div
                                                        key={project._id || index}
                                                        style={cardStyle}
                                                        onMouseEnter={(e) => Object.assign(e.currentTarget.style, cardHoverStyle)}
                                                        onMouseLeave={(e) => Object.assign(e.currentTarget.style, cardStyle)}
                                                    >

                                                        {/* Card Header: Title and Status/Category Badges */}
                                                        <div style={cardHeaderStyle}>
                                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '10px' }}>
                                                                <span style={getStatusBadgeStyle(project.status)}>
                                                                    {project.status || 'N/A'}
                                                                </span>
                                                                <span style={getCategoryBadgeStyle(project.category)}>
                                                                    {project.category || 'N/A'}
                                                                </span>
                                                                {project.isComplete && (
                                                                    <span style={{ ...cardBadgeBase, backgroundColor: '#dcfce7', color: '#166534' }}>
                                                                        ✓ Complete
                                                                    </span>
                                                                )}
                                                            </div>
                                                            <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '700', color: '#2a3290' }}>
                                                                {project.name || 'Unnamed Project'}
                                                            </h3>
                                                            <p style={{ margin: '4px 0 0', fontSize: '14px', color: '#6b7280', display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                                📍 {project.location || 'No location'}, {project.city || 'N/A'}
                                                            </p>
                                                        </div>

                                                        {/* Card Body: Key Details */}
                                                        <div style={cardBodyStyle}>
                                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', color: '#4b5563', fontSize: '14px' }}>
                                                                <DetailItem label="Configuration" value={project.configurations || 'N/A'} />
                                                                <DetailItem label="Size Range" value={project.sizes || 'N/A'} />
                                                                <DetailItem label="Price Range" value={`₹${project.price.min || 'N/A'} - ₹${project.price.max || 'N/A'}`} />
                                                                <DetailItem label="Possession" value={project.possession || 'N/A'} />
                                                                <DetailItem label="Total Area" value={project.totalProjectArea || 'N/A'} />
                                                                <DetailItem label="Units" value={project.units || 'N/A'} />

                                                                <div style={{ gridColumn: 'span 2 / span 2', borderTop: '1px solid #e5e7eb', paddingTop: '10px', marginTop: '5px' }}>
                                                                    <strong style={{ color: '#374151', display: 'block' }}>Property Type:</strong>
                                                                    <span style={{ color: '#6b7280' }}>
                                                                        {project.propertyType || 'N/A'}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Card Footer: Actions */}
                                                        <div style={cardFooterStyle}>
                                                            <button
                                                                onClick={() => handleEdit(project)}
                                                                style={{
                                                                    ...buttonStyle,
                                                                    background: '#e0e7ff',
                                                                    color: '#3730a3',
                                                                    padding: '10px 18px',
                                                                    fontWeight: '600'
                                                                }}
                                                            >
                                                                ✏️ Edit Details
                                                            </button>
                                                            {/* Show Delete button only for admin users */}
                                                            {userRole === 'admin' && (
                                                                <button
                                                                    onClick={() => handleDelete(project._id as string)}
                                                                    disabled={loading}
                                                                    style={{
                                                                        ...buttonStyle,
                                                                        background: '#fee2e2',
                                                                        color: '#991b1b',
                                                                        padding: '10px 18px',
                                                                        opacity: loading ? 0.6 : 1,
                                                                        cursor: loading ? 'not-allowed' : 'pointer',
                                                                        fontWeight: '600'
                                                                    }}
                                                                >
                                                                    🗑️ Delete
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}
                    {/* END Project List View */}

                    {/* Form View (UNCHANGED for form fields and API logic) */}
                    {viewMode === 'form' && (
                        <>
                            {/* Tabs */}
                            <div style={{ borderBottom: '1px solid #e5e7eb', background: '#f9fafb' }}>
                                <div style={{ display: 'flex', padding: '0 32px', gap: '8px', overflowX: 'auto' }}>
                                    {tabs.map(tab => (
                                        <button
                                            key={tab.id}
                                            onClick={() => setActiveTab(tab.id)}
                                            style={{
                                                padding: '16px 24px',
                                                border: 'none',
                                                background: activeTab === tab.id ? 'white' : 'transparent',
                                                color: activeTab === tab.id ? '#667eea' : '#6b7280',
                                                borderBottom: activeTab === tab.id ? '3px solid #667eea' : 'none',
                                                cursor: 'pointer',
                                                fontWeight: '600',
                                                fontSize: '14px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                transition: 'all 0.2s'
                                            }}
                                        >
                                            <span style={{ fontSize: '18px' }}>{tab.icon}</span>
                                            {tab.label}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <form onSubmit={handleSubmit} style={{ padding: '32px' }}>

                                {/* 1. Basic Info Tab */}
                                {activeTab === 'basic' && (
                                    <div style={{ display: 'grid', gap: '24px' }}>
                                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>

                                            {/* Project Name */}
                                            <div>
                                                <label style={labelStyle}>Project Name *</label>
                                                <input
                                                    type="text"
                                                    value={formData.name}
                                                    onChange={(e) => handleInputChange('name', e.target.value)}
                                                    style={inputStyle}
                                                    required
                                                />
                                            </div>

                                            {/* Developer */}
                                            <div>
                                                <label style={labelStyle}>Developer *</label>
                                                <select
                                                    value={formData.developerId}
                                                    onChange={(e) => handleInputChange('developerId', e.target.value)}
                                                    style={inputStyle}
                                                    required
                                                >
                                                    <option value="">Select Developer</option>
                                                    {developers.map(dev => (
                                                        <option key={dev._id} value={dev._id}>{dev.developerName}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* Location */}
                                            <div>
                                                <label style={labelStyle}>Location *</label>
                                                <input
                                                    type="text"
                                                    value={formData.location}
                                                    onChange={(e) => handleInputChange('location', e.target.value)}
                                                    style={inputStyle}
                                                    required
                                                />
                                            </div>

                                            {/* City */}
                                            <div>
                                                <label style={labelStyle}>City *</label>
                                                <input
                                                    type="text"
                                                    value={formData.city}
                                                    onChange={(e) => handleInputChange('city', e.target.value)}
                                                    style={inputStyle}
                                                    required
                                                />
                                            </div>

                                            {/* Property Type */}
                                            <div>
                                                <label style={labelStyle}>Property Type</label>
                                                <select
                                                    value={formData.propertyType}
                                                    onChange={(e) => handleInputChange('propertyType', e.target.value)}
                                                    style={inputStyle}
                                                >
                                                    <option>Residential Apartment</option>
                                                    <option>Villa</option>
                                                    <option>Plot</option>
                                                    <option>Commercial</option>
                                                </select>
                                            </div>

                                            {/* Status */}
                                            <div>
                                                <label style={labelStyle}>Status</label>
                                                <select
                                                    value={formData.status}
                                                    onChange={(e) => handleInputChange('status', e.target.value)}
                                                    style={inputStyle}
                                                >
                                                    <option>Launching Soon</option>
                                                    <option>Under Construction</option>
                                                    <option>Ready to Move</option>
                                                    <option>New Launch</option>
                                                </select>
                                            </div>

                                            {/* Category */}
                                            <div>
                                                <label style={labelStyle}>Category</label>
                                                <select
                                                    value={formData.category}
                                                    onChange={(e) => handleInputChange('category', e.target.value)}
                                                    style={inputStyle}
                                                >
                                                    <option>Premium</option>
                                                    <option>Luxury</option>
                                                    <option>Affordable</option>
                                                </select>
                                            </div>

                                            {/* Configurations */}
                                            <div>
                                                <label style={labelStyle}>Configurations</label>
                                                <input
                                                    type="text"
                                                    value={formData.configurations}
                                                    onChange={(e) => handleInputChange('configurations', e.target.value)}
                                                    style={inputStyle}
                                                    placeholder="e.g., 2, 3 & 4 BHK"
                                                />
                                            </div>
                                        </div>

                                        {/* Description */}
                                        <div>
                                            <label style={labelStyle}>Description</label>
                                            <textarea
                                                value={formData.description}
                                                onChange={(e) => handleInputChange('description', e.target.value)}
                                                style={{ ...inputStyle, minHeight: '100px' }}
                                                placeholder="A detailed description of the project..."
                                            />
                                        </div>

                                        {/* Price Range */}
                                        <div style={{ display: 'flex', gap: '20px' }}>
                                            <div style={{ flex: 1 }}>
                                                <label style={labelStyle}>Minimum Price (e.g., 50 Lac)</label>
                                                <input
                                                    type="text"
                                                    value={formData.price.min}
                                                    onChange={(e) => handleNestedInputChange('price', 'min', e.target.value)}
                                                    style={inputStyle}
                                                    placeholder="e.g., 50 Lac"
                                                />
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <label style={labelStyle}>Maximum Price (e.g., 1.5 Cr)</label>
                                                <input
                                                    type="text"
                                                    value={formData.price.max}
                                                    onChange={(e) => handleNestedInputChange('price', 'max', e.target.value)}
                                                    style={inputStyle}
                                                    placeholder="e.g., 1.5 Cr"
                                                />
                                            </div>
                                        </div>

                                        {/* Amenities with Icons */}
                                        <div style={{ marginTop: '24px' }}>
                                            <h3 style={sectionHeaderStyle}>Amenities with Icons</h3>
                                            {formData.amenitiesImg.map((amenity, index) => (
                                                <div key={index} style={{ border: '1px solid #e5e7eb', padding: '15px', borderRadius: '8px', marginBottom: '10px', position: 'relative' }}>
                                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                                                        <div>
                                                            <label style={labelStyle}>Amenity Label</label>
                                                            <input
                                                                type="text"
                                                                value={amenity.label}
                                                                onChange={(e) => handleObjectArrayChange('amenitiesImg', index, 'label', e.target.value)}
                                                                style={inputStyle}
                                                                placeholder="e.g., Swimming Pool"
                                                            />
                                                        </div>
                                                        <div>
                                                            <label style={labelStyle}>Icon (Upload or URL)</label>
                                                            <input
                                                                type="file"
                                                                onChange={(e) => handleObjectArrayImageUpload('amenitiesImg', index, 'icon', e)}
                                                                style={fileInputStyle}
                                                                accept="image/*"
                                                                disabled={isUploading}
                                                            />
                                                            <input
                                                                type="text"
                                                                value={amenity.icon}
                                                                onChange={(e) => handleObjectArrayChange('amenitiesImg', index, 'icon', e.target.value)}
                                                                style={{ ...inputStyle, marginTop: '5px' }}
                                                                placeholder="Or paste URL here"
                                                            />
                                                        </div>
                                                    </div>
                                                    {formData.amenitiesImg.length > 1 && (
                                                        <button
                                                            type="button"
                                                            onClick={() => removeArrayItem('amenitiesImg', index)}
                                                            style={{ ...buttonStyle, background: '#fecaca', color: '#dc2626', position: 'absolute', top: '10px', right: '10px', padding: '5px 10px' }}
                                                        >
                                                            Remove
                                                        </button>
                                                    )}
                                                </div>
                                            ))}
                                            <button
                                                type="button"
                                                onClick={() => addArrayItem('amenitiesImg')}
                                                style={{ ...buttonStyle, background: '#fef3c7', color: '#92400e' }}
                                            >
                                                + Add Amenity with Icon
                                            </button>
                                        </div>

                                        {/* Is Complete Checkbox - Only for Admin */}
                                        {userRole === 'admin' && (
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                                <label style={{ ...labelStyle, marginBottom: 0 }}>Project Complete?</label>
                                                <input
                                                    type="checkbox"
                                                    checked={formData.isComplete}
                                                    onChange={(e) => handleInputChange('isComplete', e.target.checked)}
                                                    style={{ width: 'auto', transform: 'scale(1.2)' }}
                                                />
                                            </div>
                                        )}

                                    </div>
                                )}

                                {/* 2. Details Tab */}
                                {activeTab === 'details' && (
                                    <div style={{ display: 'grid', gap: '24px' }}>
                                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>

                                            {/* Towers */}
                                            <div>
                                                <label style={labelStyle}>Towers</label>
                                                <input type="text" value={formData.towers} onChange={(e) => handleInputChange('towers', e.target.value)} style={inputStyle} placeholder="e.g., 5" />
                                            </div>

                                            {/* Floors */}
                                            <div>
                                                <label style={labelStyle}>Floors</label>
                                                <input type="text" value={formData.floors} onChange={(e) => handleInputChange('floors', e.target.value)} style={inputStyle} placeholder="e.g., G+20" />
                                            </div>

                                            {/* Units */}
                                            <div>
                                                <label style={labelStyle}>Units</label>
                                                <input type="text" value={formData.units} onChange={(e) => handleInputChange('units', e.target.value)} style={inputStyle} placeholder="e.g., 450" />
                                            </div>

                                            {/* Sizes */}
                                            <div>
                                                <label style={labelStyle}>Sizes (Range)</label>
                                                <input type="text" value={formData.sizes} onChange={(e) => handleInputChange('sizes', e.target.value)} style={inputStyle} placeholder="e.g., 1200 - 2500 Sq.Ft." />
                                            </div>

                                            {/* Total Project Area */}
                                            <div>
                                                <label style={labelStyle}>Total Project Area</label>
                                                <input type="text" value={formData.totalProjectArea} onChange={(e) => handleInputChange('totalProjectArea', e.target.value)} style={inputStyle} placeholder="e.g., 10 Acres" />
                                            </div>

                                            {/* Possession */}
                                            <div>
                                                <label style={labelStyle}>Possession</label>
                                                <input type="text" value={formData.possession} onChange={(e) => handleInputChange('possession', e.target.value)} style={inputStyle} placeholder="e.g., December 2026" />
                                            </div>

                                            {/* RERA ID */}
                                            <div>
                                                <label style={labelStyle}>RERA ID</label>
                                                <input type="text" value={formData.reraId} onChange={(e) => handleInputChange('reraId', e.target.value)} style={inputStyle} />
                                            </div>

                                            {/* RERA Link */}
                                            <div>
                                                <label style={labelStyle}>RERA Link</label>
                                                <input type="url" value={formData.reraLink} onChange={(e) => handleInputChange('reraLink', e.target.value)} style={inputStyle} placeholder="https://" />
                                            </div>

                                            {/* Map Location URL */}
                                            <div>
                                                <label style={labelStyle}>Map Location (iFrame URL)</label>
                                                <input type="url" value={formData.mapLocation} onChange={(e) => handleInputChange('mapLocation', e.target.value)} style={inputStyle} placeholder="https://maps.google.com/embed?..." />
                                            </div>

                                            {/* Latitude */}
                                            <div>
                                                <label style={labelStyle}>Latitude</label>
                                                <input type="text" value={formData.latitude} onChange={(e) => handleInputChange('latitude', e.target.value)} style={inputStyle} />
                                            </div>

                                            {/* Longitude */}
                                            <div>
                                                <label style={labelStyle}>Longitude</label>
                                                <input type="text" value={formData.longitude} onChange={(e) => handleInputChange('longitude', e.target.value)} style={inputStyle} />
                                            </div>
                                        </div>

                                        {/* Location Bullet Points */}
                                        <h3 style={sectionHeaderStyle}>Location Highlights/Bullet Points</h3>
                                        <div>
                                            {formData.locationBulletPoint.map((point, index) => (
                                                <div key={index} style={arrayInputGroupStyle}>
                                                    <input
                                                        type="text"
                                                        value={point}
                                                        onChange={(e) => handleArrayChange('locationBulletPoint', index, e.target.value)}
                                                        style={inputStyle}
                                                        placeholder={`Location Point ${index + 1}`}
                                                    />
                                                    {formData.locationBulletPoint.length > 1 && (
                                                        <button
                                                            type="button"
                                                            onClick={() => removeArrayItem('locationBulletPoint', index)}
                                                            style={{ ...buttonStyle, background: '#fecaca', color: '#dc2626', flexShrink: 0 }}
                                                        >
                                                            -
                                                        </button>
                                                    )}
                                                </div>
                                            ))}
                                            <button
                                                type="button"
                                                onClick={() => addArrayItem('locationBulletPoint')}
                                                style={{ ...buttonStyle, background: '#dbeafe', color: '#1e40af' }}
                                            >
                                                + Add Location Point
                                            </button>
                                        </div>

                                        {/* FAQ Section */}
                                        <h3 style={sectionHeaderStyle}>FAQ (Frequently Asked Questions)</h3>
                                        {formData.faq.map((faqItem, index) => (
                                            <div key={index} style={{ border: '1px solid #e5e7eb', padding: '15px', borderRadius: '8px', marginBottom: '10px', position: 'relative' }}>
                                                <div style={{ display: 'grid', gap: '10px' }}>
                                                    <div>
                                                        <label style={labelStyle}>Question</label>
                                                        <input
                                                            type="text"
                                                            value={faqItem.question}
                                                            onChange={(e) => handleObjectArrayChange('faq', index, 'question', e.target.value)}
                                                            style={inputStyle}
                                                            placeholder="Enter question"
                                                        />
                                                    </div>
                                                    <div>
                                                        <label style={labelStyle}>Answer</label>
                                                        <textarea
                                                            value={faqItem.answer}
                                                            onChange={(e) => handleObjectArrayChange('faq', index, 'answer', e.target.value)}
                                                            style={{ ...inputStyle, minHeight: '80px' }}
                                                            placeholder="Enter answer"
                                                        />
                                                    </div>
                                                </div>
                                                {formData.faq.length > 1 && (
                                                    <button
                                                        type="button"
                                                        onClick={() => removeArrayItem('faq', index)}
                                                        style={{ ...buttonStyle, background: '#fecaca', color: '#dc2626', position: 'absolute', top: '10px', right: '10px', padding: '5px 10px' }}
                                                    >
                                                        Remove
                                                    </button>
                                                )}
                                            </div>
                                        ))}
                                        <button
                                            type="button"
                                            onClick={() => addArrayItem('faq')}
                                            style={{ ...buttonStyle, background: '#fef3c7', color: '#92400e' }}
                                        >
                                            + Add FAQ
                                        </button>

                                    </div>
                                )}

                                {/* 3. Media Tab */}
                                {activeTab === 'media' && (
                                    <div style={{ display: 'grid', gap: '24px' }}>

                                        <h3 style={sectionHeaderStyle}>Banner Images</h3>
                                        <div>
                                            {formData.bannerimg.map((imgUrl, index) => (
                                                <div key={index} style={{ ...arrayInputGroupStyle, alignItems: 'center' }}>
                                                    <input
                                                        type="file"
                                                        onChange={(e) => handleArrayImageUpload('bannerimg', index, e)}
                                                        style={fileInputStyle}
                                                        accept="image/*"
                                                        disabled={isUploading}
                                                    />
                                                    <input
                                                        type="text"
                                                        value={imgUrl}
                                                        onChange={(e) => handleArrayChange('bannerimg', index, e.target.value)}
                                                        style={{ ...inputStyle, flex: 1 }}
                                                        placeholder="Or paste URL here"
                                                    />
                                                    {formData.bannerimg.length > 1 && (
                                                        <button
                                                            type="button"
                                                            onClick={() => removeArrayItem('bannerimg', index)}
                                                            style={{ ...buttonStyle, background: '#fecaca', color: '#dc2626', flexShrink: 0 }}
                                                        >
                                                            -
                                                        </button>
                                                    )}
                                                </div>
                                            ))}
                                            <button
                                                type="button"
                                                onClick={() => addArrayItem('bannerimg')}
                                                style={{ ...buttonStyle, background: '#d1fae5', color: '#065f46' }}
                                            >
                                                + Add Banner Image
                                            </button>
                                        </div>

                                        <h3 style={sectionHeaderStyle}>Gallery Images</h3>
                                        <div>
                                            {formData.galleryImages.map((imgUrl, index) => (
                                                <div key={index} style={{ ...arrayInputGroupStyle, alignItems: 'center' }}>
                                                    <input
                                                        type="file"
                                                        onChange={(e) => handleArrayImageUpload('galleryImages', index, e)}
                                                        style={fileInputStyle}
                                                        accept="image/*"
                                                        disabled={isUploading}
                                                    />
                                                    <input
                                                        type="text"
                                                        value={imgUrl}
                                                        onChange={(e) => handleArrayChange('galleryImages', index, e.target.value)}
                                                        style={{ ...inputStyle, flex: 1 }}
                                                        placeholder="Or paste URL here"
                                                    />
                                                    {formData.galleryImages.length > 1 && (
                                                        <button
                                                            type="button"
                                                            onClick={() => removeArrayItem('galleryImages', index)}
                                                            style={{ ...buttonStyle, background: '#fecaca', color: '#dc2626', flexShrink: 0 }}
                                                        >
                                                            -
                                                        </button>
                                                    )}
                                                </div>
                                            ))}
                                            <button
                                                type="button"
                                                onClick={() => addArrayItem('galleryImages')}
                                                style={{ ...buttonStyle, background: '#d1fae5', color: '#065f46' }}
                                            >
                                                + Add Gallery Image
                                            </button>
                                        </div>

                                        <h3 style={sectionHeaderStyle}>Project Highlights (Text)</h3>

                                        {formData.highlight.map((text, index) => (
                                            <div key={index} style={arrayInputGroupStyle}>
                                                <input
                                                    type="text"
                                                    value={text}
                                                    onChange={(e) => handleArrayChange('highlight', index, e.target.value)}
                                                    style={inputStyle}
                                                    placeholder={`Highlight Text ${index + 1}`}
                                                />
                                                {formData.highlight.length > 1 && (
                                                    <button
                                                        type="button"
                                                        onClick={() => removeArrayItem('highlight', index)}
                                                        style={{ ...buttonStyle, background: '#fecaca', color: '#dc2626' }}
                                                    >
                                                        -
                                                    </button>
                                                )}
                                            </div>
                                        ))}

                                        <button
                                            type="button"
                                            onClick={() => addArrayItem('highlight')}
                                            style={{ ...buttonStyle, background: '#fef3c7', color: '#92400e' }}
                                        >
                                            + Add Highlight Text
                                        </button>


                                        <h3 style={sectionHeaderStyle}>Project Highlights (Images)</h3>

                                        {formData.highlightImg.map((img, index) => (
                                            <div key={index} style={{ ...arrayInputGroupStyle, alignItems: 'center' }}>
                                                <input
                                                    type="file"
                                                    onChange={(e) => handleArrayImageUpload('highlightImg', index, e)}
                                                    style={fileInputStyle}
                                                    accept="image/*"
                                                    disabled={isUploading}
                                                />
                                                <input
                                                    type="text"
                                                    value={img}
                                                    onChange={(e) => handleArrayChange('highlightImg', index, e.target.value)}
                                                    style={{ ...inputStyle, flex: 1 }}
                                                    placeholder={`Highlight Image ${index + 1}`}
                                                />
                                                {formData.highlightImg.length > 1 && (
                                                    <button
                                                        type="button"
                                                        onClick={() => removeArrayItem('highlightImg', index)}
                                                        style={{ ...buttonStyle, background: '#fecaca', color: '#dc2626' }}
                                                    >
                                                        -
                                                    </button>
                                                )}
                                            </div>
                                        ))}

                                        <button
                                            type="button"
                                            onClick={() => addArrayItem('highlightImg')}
                                            style={{ ...buttonStyle, background: '#d1fae5', color: '#065f46' }}
                                        >
                                            + Add Highlight Image
                                        </button>


                                        <h3 style={sectionHeaderStyle}>PDF Brochure/File</h3>
                                        <div>
                                            <label style={labelStyle}>Project PDF/Brochure (Upload or URL)</label>
                                            <input
                                                type="file"
                                                onChange={(e) => handleImageUpload('pdf', e)}
                                                style={fileInputStyle}
                                                accept=".pdf"
                                                disabled={isUploading}
                                            />
                                            <input
                                                type="text"
                                                value={formData.pdf}
                                                onChange={(e) => handleInputChange('pdf', e.target.value)}
                                                style={{ ...inputStyle, marginTop: '5px' }}
                                                placeholder="Or paste PDF URL here"
                                            />
                                            {isUploading && <p style={{ color: '#059669', marginTop: '10px' }}>Uploading PDF...</p>}
                                            {formData.pdf && <p style={{ marginTop: '10px' }}>Current PDF: <a href={formData.pdf} target="_blank" rel="noopener noreferrer" style={{ color: '#667eea', textDecoration: 'underline' }}>View PDF</a></p>}
                                        </div>
                                    </div>
                                )}

                                {/* 4. Pricing Tab */}
                                {activeTab === 'pricing' && (
                                    <div style={{ display: 'grid', gap: '24px' }}>
                                        <h3 style={sectionHeaderStyle}>Price Table Configuration</h3>
                                        {formData.priceTableType.map((row, index) => (
                                            <div key={index} style={{ border: '1px solid #e5e7eb', padding: '20px', borderRadius: '8px', position: 'relative', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', marginBottom: '10px' }}>

                                                {/* BHK Type */}
                                                <div>
                                                    <label style={labelStyle}>BHK Type</label>
                                                    <input
                                                        type="text"
                                                        value={row.bhktype}
                                                        onChange={(e) => handleObjectArrayChange('priceTableType', index, 'bhktype', e.target.value)}
                                                        style={inputStyle}
                                                        placeholder="e.g., 2 BHK"
                                                    />
                                                </div>

                                                {/* Size */}
                                                <div>
                                                    <label style={labelStyle}>Size</label>
                                                    <input
                                                        type="text"
                                                        value={row.size}
                                                        onChange={(e) => handleObjectArrayChange('priceTableType', index, 'size', e.target.value)}
                                                        style={inputStyle}
                                                        placeholder="e.g., 1250 Sq.Ft."
                                                    />
                                                </div>

                                                {/* Price */}
                                                <div>
                                                    <label style={labelStyle}>Price</label>
                                                    <input
                                                        type="text"
                                                        value={row.price}
                                                        onChange={(e) => handleObjectArrayChange('priceTableType', index, 'price', e.target.value)}
                                                        style={inputStyle}
                                                        placeholder="e.g., 1.25 Cr"
                                                    />
                                                </div>

                                                {/* Image Upload */}
                                                <div style={{ gridColumn: 'span 2 / span 2' }}>
                                                    <label style={labelStyle}>Image (Floor Plan/Unit Map)</label>
                                                    <input
                                                        type="file"
                                                        onChange={(e) => handleObjectArrayImageUpload('priceTableType', index, 'img', e)}
                                                        style={fileInputStyle}
                                                        accept="image/*"
                                                        disabled={isUploading}
                                                    />
                                                    <input
                                                        type="text"
                                                        value={row.img}
                                                        onChange={(e) => handleObjectArrayChange('priceTableType', index, 'img', e.target.value)}
                                                        style={{ ...inputStyle, marginTop: '5px' }}
                                                        placeholder="Or paste URL here"
                                                    />
                                                </div>

                                                {formData.priceTableType.length > 1 && (
                                                    <button
                                                        type="button"
                                                        onClick={() => removeArrayItem('priceTableType', index)}
                                                        style={{ ...buttonStyle, background: '#fecaca', color: '#dc2626', position: 'absolute', top: '10px', right: '10px', padding: '5px 10px' }}
                                                    >
                                                        Remove
                                                    </button>
                                                )}
                                            </div>
                                        ))}
                                        <button
                                            type="button"
                                            onClick={() => addArrayItem('priceTableType')}
                                            style={{ ...buttonStyle, background: '#d1fae5', color: '#065f46' }}
                                        >
                                            + Add Price Row
                                        </button>
                                    </div>
                                )}

                                {/* 5. SEO Tab */}
                                {activeTab === 'seo' && (
                                    <div style={{ display: 'grid', gap: '24px' }}>
                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '20px' }}>

                                            {/* Meta Title */}
                                            <div>
                                                <label style={labelStyle}>Meta Title</label>
                                                <input type="text" value={formData.metaTitle} onChange={(e) => handleInputChange('metaTitle', e.target.value)} style={inputStyle} />
                                            </div>

                                            {/* Meta Description */}
                                            <div>
                                                <label style={labelStyle}>Meta Description</label>
                                                <textarea value={formData.metaDesc} onChange={(e) => handleInputChange('metaDesc', e.target.value)} style={{ ...inputStyle, minHeight: '80px' }} />
                                            </div>

                                            {/* Meta Keywords */}
                                            <div>
                                                <label style={labelStyle}>Meta Keywords (Comma separated)</label>
                                                <textarea value={formData.metaKeywords} onChange={(e) => handleInputChange('metaKeywords', e.target.value)} style={{ ...inputStyle, minHeight: '80px' }} />
                                            </div>

                                            {/* Meta Schema */}
                                            <div>
                                                <label style={labelStyle}>Meta Schema (JSON-LD)</label>
                                                <textarea value={formData.metaSchema} onChange={(e) => handleInputChange('metaSchema', e.target.value)} style={{ ...inputStyle, minHeight: '150px', fontFamily: 'monospace' }} />
                                            </div>

                                            {/* Slug */}
                                            <div>
                                                <label style={labelStyle}>Slug (URL-friendly name)</label>
                                                <input type="text" value={formData.slug} onChange={(e) => handleInputChange('slug', e.target.value)} style={inputStyle} placeholder="project-name-in-city" />
                                            </div>

                                            {/* Canonical URL */}
                                            <div>
                                                <label style={labelStyle}>Canonical URL (Optional)</label>
                                                <input type="url" value={formData.conalical} onChange={(e) => handleInputChange('conalical', e.target.value)} style={inputStyle} placeholder="https://yourwebsite.com/projects/slug" />
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Form Message (Internal Note/Status) */}
                                <div style={{ marginTop: '24px', borderTop: '1px solid #e5e7eb', paddingTop: '24px' }}>
                                    <label style={labelStyle}>Internal Form Message / Status Note</label>
                                    <input type="text" value={formData.formMessage} onChange={(e) => handleInputChange('formMessage', e.target.value)} style={inputStyle} />
                                </div>

                                {/* Submit/Action Buttons */}
                                <div style={{ marginTop: '32px', paddingTop: '24px', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                                    <button
                                        type="button"
                                        onClick={handleReset}
                                        style={{ ...buttonStyle, background: '#f3f4f6', color: '#4b5563' }}
                                        disabled={loading}
                                    >
                                        <span style={{ fontSize: '16px' }}>🧹</span> Reset Form
                                    </button>
                                    <button
                                        type="submit"
                                        disabled={loading}
                                        style={{
                                            ...buttonStyle,
                                            background: 'linear-gradient(90deg, #10b981 0%, #059669 100%)',
                                            color: 'white',
                                            padding: '12px 24px',
                                            opacity: loading ? 0.7 : 1,
                                            cursor: loading ? 'not-allowed' : 'pointer'
                                        }}
                                    >
                                        {loading ? (
                                            'Processing...'
                                        ) : (
                                            <>
                                                <span style={{ fontSize: '16px' }}>💾 </span> {editingProjectId ? 'Update Project' : 'Create Project'}
                                            </>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

// Helper component for cleaner detail display in the card
const DetailItem: React.FC<{ label: string, value: string }> = ({ label, value }) => (
    <div style={{ margin: 0 }}>
        <strong style={{ color: '#374151', display: 'block', marginBottom: '2px' }}>{label}:</strong>
        <span style={{ color: '#6b7280' }}>{value}</span>
    </div>
);


export default ProjectDashboard;